import {
  RegulationFilterModel,
  RegulationViewModel,
  RegulationModel,
} from '../../core/models/regulation';

import { FormControl } from '@angular/forms';
import { ENTER, COMMA } from '@angular/cdk/keycodes';
import { UserProfile } from '../../core/models/user';
import {
  ItemArraryModel,
  ItemIdModel,
} from './../../core/models/filter-model/item-id-model';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { MasterHelper, Logger } from '../../core/utilities';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { AlertDialogModel } from 'src/app/core/models/view-model';
import {
  StaticRegulationLibrary,
  StaticLibraryViewModel,
} from './../../core/models/regulation/static-regulation-library';
import { RegulationService } from '../../core/services/regulation';
import { ItemInfoDto } from 'src/app/core/models/rulebook/item.info-dto';
import { Component, OnInit, ViewChild, ElementRef, HostListener, Input, SimpleChanges, OnChanges, AfterViewInit, ViewChildren, QueryList } from '@angular/core';
import { GDPRService } from './../../core/services/rulebook/gdpr.service';
import { SessionService } from '../../core/services/auth/session.service';
import { LibraryType } from './../../core/enums/regulator/regulator-status';
import { CommonService } from 'src/app/core/services/common/common.service';
import { ToastViewModel } from './../../core/models/view-model/toast-view-model';
import { BulkCloseModel } from 'src/app/core/models/regulation/bulk-close-model';
import { ItemActiveModel } from 'src/app/core/models/view-model/item-acive-model';
import { RegulationDetail } from './../../core/models/regulation/regulation-detail';
//import { RegulatorStatusLabel } from 'src/app/core/enums/regulator/regulator-status';
import { LibraryDataModel } from 'src/app/core/models/view-model/library-data-model';
import { ChangeViewerLibrary } from 'src/app/core/models/regulation/change-viewer-library';
import { FilterItemListModel } from './../../core/models/filter-model/filter-item-list-model';
import { RegulationColumnModel } from 'src/app/core/models/regulation/regulation-column-model';
import { StaticLibraryEditView } from 'src/app/core/models/view-model/static-library-edit-view';
import { EditInfoDialogComponent } from '../shared/edit-info-dialog/edit-info-dialog.component';
import { AssessmentDialogComponent } from '../shared/assessment-dialog/assessment-dialog.component';
import { UserManagementService } from 'src/app/core/services/user-management/user-management.service';
import { GroupingRegulationViewModel, RegulationDataModel, RegulationDescription, RegulationResultModel } from 'src/app/core/models/regulation/regulation.model';
import { BulkCloseDialogComponent } from '../distributed-ui-components/bulk-close-dialog/bulk-close-dialog.component';
import { PublishRegulationFilter, PublishReportResponse } from 'src/app/core/models/regulation/publish-regulation-model';
import { JurisdictionDialogComponent } from '../distributed-ui-components/jurisdiction-dialog/jurisdiction-dialog.component';
import { ShareLibraryDialogComponent } from './../distributed-ui-components/share-library-dialog/share-library-dialog.component';
import { ChangeViewerDialogComponent } from './../distributed-ui-components/change-viewer-dialog/change-viewer-dialog.component';
import { StaticLibraryDialogComponent } from './../distributed-ui-components/static-library-dialog/static-library-dialog.component';
import { PublishReportDialogComponent } from './../distributed-ui-components/publish-report-dialog/publish-report-dialog.component';
import { ChangeViewerAnalyticDialogComponent } from '../shared/change-viewer-analytic-dialog/change-viewer-analytic-dialog.component';
import { RegulationLibraryDialogComponent } from './../distributed-ui-components/regulation-library-dialog/regulation-library-dialog.component';
import { UserService } from 'src/app/core/services/user';
import { AddManualUpdateComponent } from '../manual-update/add-manual-update/add-manual-update.component';
import { SingleImportUpdateModel } from 'src/app/core/models/manualUpdates/single-import';
import { ModalDialogComponent } from '../distributed-ui-components/modal-dialog/modal-dialog.component';
import { formatDate } from '@angular/common';
import { GeneralDataService } from 'src/app/core/services/general/general-data.service';
import { RegulationStatusInfoModel } from 'src/app/core/models/regulation/regulation-status-info-model';
import { BulkInsertModel } from 'src/app/core/models/impact-assessment/bulk-insert-model';
import { GroupingModel } from 'src/app/core/models/regulation/regulation-filter.model';
import { Store } from '@ngrx/store';
import { addPannelData, setPannelData, setGroupData, updateFilter, updateFilterType, updateGroupBy, updateGroupByEnabled, updateGroupPagination, updatePannelOpenState, updatePannelPagination } from 'src/app/state/grouping/grouping.actions';
import { Observable } from 'rxjs';
import { increment } from 'src/app/state/test/test.actions';
import { getFilter, getFilterType, getGroupBy, getGroupByEnabled, getGroupData, getGroupPagination, getNavHeight, getPannelData, getPannelDataLength, getPannelOpenState, getPannelPagination } from 'src/app/state/grouping/grouping.selector';
import { groupingState, GroupState } from 'src/app/state/grouping/grouping.reducer';
import { first } from 'rxjs/operators';
import { MatAutocomplete, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatDialog } from '@angular/material/dialog';
import { MatChipInputEvent } from '@angular/material/chips';
import { BsDropdownDirective } from 'ngx-bootstrap/dropdown';
import { RegulatoryFiltersComponent } from '../distributed-ui-components/regulatory-filters/regulatory-filters.component';
import { Tooltip } from 'primeng/tooltip';
import { AppendAssessListComponent } from '../distributed-ui-components/append-assess-list/append-assess-list.component';
import { MergeAssess } from 'src/app/core/models/regulation/merge-assess-model';
import { GlobalService } from 'src/app/core/services/global/global.service';
import { debug } from 'console';
import { an } from '@fullcalendar/core/internal-common';

@Component({
  selector: 'app-change-viewer',
  templateUrl: './change-viewer.component.html',
  styleUrls: ['./change-viewer.component.scss'],
})
export class ChangeViewerComponent implements OnInit, OnChanges, AfterViewInit {
  public status: Array<RegulationStatusInfoModel> = [];
  public toolTip: any;
  // public status:RegulationStatusInfoModel = {
  //   id: 0,
  //   regulationStatus: '',
  //   closedType: '',
  //   comment: '',
  //   jurisdiction: '',
  //   userId: '',
  //   userName: '',
  //   linkedIds: ''
  // };
  @ViewChild(CdkVirtualScrollViewport)
  viewport!: CdkVirtualScrollViewport;

  @ViewChild('pubTypeSubAutocomplete')
  pubTypeSubAutocomplete!: MatAutocomplete;
  @ViewChild('pubTypeSubInput')
  pubTypeSubInput!: ElementRef<HTMLInputElement>;
  resultRegulations: RegulationResultModel = new RegulationResultModel();

  regulations: RegulationViewModel;
  allRegulations: RegulationModel[];
  isBackdropVisible = false;
  isLoadingRegulations = false;
  isDownloading = false;
  isRegulationFetched = false;
  showMoreFilters = false;
  regulationFilter: RegulationFilterModel;
  groupingFilter: GroupingModel;
  currentPageNumber = 1;
  totalPageCount = 0;
  isLoadingPagination = false;
  endIndex = 0;
  selectable = true;
  removable = true;
  addOnBlur = true;
  myInnerHeight: any;
  toastModel: ToastViewModel;
  isToastShow = false;
  ChangeViewerDropdown = true;
  regulationDetail: RegulationDetail;
  selectedItemId: number;
  selectedItems: Array<number>;
  // selectedItemsPanel
  bulkCloseData: BulkCloseModel;
  newIAAItemIdList: Array<number>;
  vCode = '';
  lCode = '';
  aCode = '';
  cCode = '';
  bcCode = '';
  eCode = '';
  erCode = '';
  userJurisdiction: Array<ItemIdModel>;
  collapsedIds: Array<number>;
  regulationLibraryId = 0;
  regulationLibraryType: LibraryType;
  showMoreSimilarity: Array<number> = [];
  user: UserProfile;
  itemActiveModel!: Array<ItemActiveModel>;
  tableWidth = 1000;
  regType = '_regcol';
  regColumn: RegulationColumnModel;


  pubTypeSubCntrl: FormControl = new FormControl();
  searchFilterFormControl: FormControl = new FormControl();
  selectedPubTypeSubFilters: string[] = [];
  separatorKeysCodes: number[] = [ENTER, COMMA];
  searchedSubType: string[] = [];
  pubTypeSubFilters: string[] = [];
  searchedSubTopic: string[] = [];


  filterPersistenceKey = 'regulationFilter';
  @ViewChild('dropdown') filterDropDown: any;
  totalFilter: number = 0;
  lastSelected: number = 0;
  lastSelectedPanel: number = 0;
  lastSelectedSmallPanel: number = 0;
  isShiftSelect: boolean = true;
  @Input()
  callingLocation!: string;
  @Input()
  trndingTopicsRegulationFilter!: RegulationFilterModel;
  @Input()
  someInput!: string;
  clickedFilter!: string;


  // grouping
  groupData: GroupState[]
  groupBy!: "PubType" | "Country" | "MappingId";
  groupPageIndex!: number;
  groupFilter!: string[];
  groupFilterType!: string;
  filteredGroupData!: any[];
  searchFilterFormList!: string[];
  isFirstTimeLoad!: boolean;
  actionedIds: Array<number>;

  @ViewChild('searchFilter')
  searchFilterInput!: MatAutocomplete;
  selectedPanelData!: string;
  selectedPanelName: Array<string>;
  selectedSubPanelName: Array<string>;
  @ViewChild('dropdownfilters')
  dropdownfilters!: BsDropdownDirective;
  IsOpenFilter: boolean = false;
  @ViewChild('regulatoryFiltersComponent')
  regulatoryFiltersComponent!: RegulatoryFiltersComponent;
  templateNo: number = 0;
  //description Tooltip
  tooltipText = '';
  isShowingTooltip: boolean = false;
  lastTooltipId!: number;
  @ViewChildren(Tooltip) tooltips!: QueryList<Tooltip>;
  selectedImpactId: number = 0;
  constructor(
    private regulationService: RegulationService,
    private sessionService: SessionService,
    private gdprService: GDPRService,
    public dialog: MatDialog,
    public commonService: CommonService,
    private userService: UserManagementService,
    private router: Router,
    private eleRef: ElementRef,
    private route: ActivatedRoute,
    private _userService: UserService,
    private generalService: GeneralDataService,
    private store: Store<any>,
    private _globalService: GlobalService
  ) {
    this.myInnerHeight = window.innerHeight - 200;
    this.regulations = new RegulationViewModel();
    this.allRegulations = new Array<RegulationModel>();
    this.regulationFilter = new RegulationFilterModel();
    this.groupingFilter = new GroupingModel();
    this.user = new UserProfile();
    this.toastModel = new ToastViewModel();
    this.regulationDetail = new RegulationDetail();
    this.groupData = new Array<GroupState>();
    // this.groupPageIndex = 0;
    const persistFilter = JSON.parse(this.fetchFromBrowser(this.filterPersistenceKey) as string) as RegulationFilterModel;
    if (persistFilter) {
      persistFilter.Page = 1;
      this.regulationFilter = persistFilter;
    }
    const url = this.router.url;
    this.newIAAItemIdList = this.fetchFromBrowser('_iadid') ? (JSON.parse(this.fetchFromBrowser('_iadid') as string) as number[]) : [];
    this.selectedItemId = 0;
    this.selectedItems = [];
    this.actionedIds = [];
    this.selectedPanelName = [];
    this.selectedSubPanelName = [];
    this.bulkCloseData = new BulkCloseModel();
    this.userJurisdiction = [];
    this.collapsedIds = [];
    this.regColumn = new RegulationColumnModel();
    if (url.indexOf('/change-viewer/regulation-library') >= 0) {
      // tslint:disable-next-line:no-string-literal
      this.regulationLibraryId = Number(this.route.snapshot.params['id']);
      // tslint:disable-next-line:no-string-literal
      this.regulationLibraryType = Number(this.route.snapshot.params['type']);
      this.sessionService.regLibraryId =
        this.regulationFilter.regulationLibraryId;
      this.regulationFilter.FilterType = 'Other';
    } else {
      this.regulationFilter.regulationLibraryId = 0;
      this.regulationLibraryType = LibraryType.Unknown;
      this.regulationFilter.regulationLibraryType = LibraryType.Unknown;
      this.sessionService.regLibraryId = 0;
      this.regulationFilter.FilterType = url ? url === '/change-viewer/open' ? 'Open'
        : url === '/change-viewer/actioned' ? 'Actioned' : url === '/change-viewer/future-updates'
          ? 'Future Updates' : 'Other' : 'Open';
    }
    this.columnInfo();


    // grouping

    this.store.select(getGroupBy).subscribe(res => {
      this.groupBy = res;
    })

    this.store.select(getGroupPagination).subscribe(res => {
      this.groupPageIndex = res;
    })

    this.store.select(getFilter).subscribe(res => {
      this.groupFilter = JSON.parse(JSON.stringify(res));
      this.searchFilter();
    })
    this.store.select(getFilterType).subscribe(res => {
      this.groupFilterType = res;
    })
    this.store.select(getNavHeight).subscribe(res => {
      this.eleRef.nativeElement.style.setProperty('--dd-nav-height', res + 'px');
    })
    // this.groupByEnabled$ = this.store.select(getGroupByEnabled)
    // this.groupBy$ = this.store.select(getGroupBy)
    // this.columnsToDisplay = [
    //   "id",
    //   "geography",
    //   "country",
    //   "regulator",
    //   "publishDate",
    //   "type",
    //   "title",
    //   "action"
    // ]
  }

  ngOnInit(): void {

    this.isLoadingRegulations = true;

    this.regulationFilter.SortKey = 'Date';
    this.getActionCode();
    this.getUserProfile();
    this.removeFromBrowser('_iadid');
    this.IsRowEdited();
    //this.countFiltersItem();
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };

    this.router.events.subscribe((evt) => {
      if (evt instanceof NavigationEnd) {
        // this.router.navigated = false;
        window.scrollTo(0, 0);
      }
    });
    this.generalService.getDivisionSelected().subscribe(res => {
      this.regulationFilter.divisionId = res;
      this.saveOnBrowser(this.filterPersistenceKey, JSON.stringify(this.regulationFilter));
      this.getRegulation();
    })
    this.searchFilterFormControl.valueChanges.subscribe((term: string) => {
      let groupDataList = this.groupData.map(e => e.groupByColumnData)
      let filterList = term ? groupDataList.filter(e => e.toLowerCase().includes(term.toLowerCase())) : groupDataList;
      this.groupFilter.forEach(e => {
        if (filterList.includes(e))
          filterList.splice(filterList.indexOf(e), 1)
      })
      this.searchFilterFormList = filterList
    });

  }

  ngAfterViewInit(): void {
    // let navHeight = this.changeViewerNav.nativeElement.offsetHeight;
  }

  ngOnChanges(changes: SimpleChanges) {
    // changes.prop contains the old and the new value...
    if (!changes?.trndingTopicsRegulationFilter?.firstChange) {
      this.getRegulation();
      this.IsRowEdited();
    }
  }
  columnInfo(): void {
    this.eleRef.nativeElement.style.setProperty('--dd-height', '250px');
    this.itemActiveModel = [
      { itemTitle: 'Id', itemWidth: 90, isActive: true },
      { itemTitle: 'Geography', itemWidth: 90, isActive: true },
      { itemTitle: 'Country', itemWidth: 80, isActive: true },
      { itemTitle: 'Regulator', itemWidth: 90, isActive: true },
      { itemTitle: 'Publish Date', itemWidth: 130, isActive: true },
      { itemTitle: 'Pub Type', itemWidth: 180, isActive: true },
      { itemTitle: 'Title', itemWidth: 400, isActive: true },
      { itemTitle: 'Is Manual', itemWidth: 90, isActive: true },
      { itemTitle: 'FinregE Topics', itemWidth: 90, isActive: true },
      { itemTitle: 'Org Topics', itemWidth: 90, isActive: true },
      { itemTitle: 'Group By', itemWidth: 90, isActive: false },
    ];
  }
  checkGroupBy() {
    return this.itemActiveModel.find(i => i.itemTitle == 'Group By')?.isActive;
  }
  columnSettings(): void {
    const persistColumn = JSON.parse(this.fetchFromBrowser(this.regType) as string) as ItemActiveModel[];
    if (persistColumn) {
      this.itemActiveModel = this.itemActiveModel.length > persistColumn.length ? this.itemActiveModel : persistColumn;
      this.store.dispatch(updateGroupByEnabled({ data: this.itemActiveModel.find(i => i.itemTitle == 'Group By')?.isActive ? true : false }))
    }
    this.eleRef.nativeElement.style.setProperty('--table-min-width', this.tableWidth + 'px');
    this.itemActiveModel.forEach((element) => {
      this.showHideColumn(element.itemTitle, element.itemWidth, element.isActive, 'OnLoad');
    });
  }

  getActionCode(): void {
    const url = this.router.url;
    this.vCode =
      url === '/change-viewer/open' ? 'OV' : url === '/change-viewer/actioned' ? 'ACTV' : url === '/change-viewer/other-updates' ? 'OUV' : 'FUV';
    this.lCode = url === '/change-viewer/open' ? 'OL'
      : url === '/change-viewer/actioned' ? 'ACTL' : url === '/change-viewer/other-updates' ? 'OUL' : 'FUL';
    this.aCode = url === '/change-viewer/open'
      ? 'OA' : url === '/change-viewer/actioned' ? 'ACTA' : url === '/change-viewer/other-updates' ? 'OUA' : 'FUA';
    this.cCode = url === '/change-viewer/open'
      ? 'OC' : url === '/change-viewer/actioned' ? 'ACTC' : url === '/change-viewer/other-updates' ? 'OUC' : 'FUC';
    this.bcCode = url === '/change-viewer/open'
      ? 'OBC' : url === '/change-viewer/actioned' ? 'ACTBC' : url === '/change-viewer/other-updates' ? 'OUBC' : 'FUBC';
    this.eCode = url === '/change-viewer/actioned' ? 'ACTE' : '';
    this.erCode =
      url.indexOf('/change-viewer/regulation-library') >= 0
        ? 'OER' : url === '/change-viewer/open' ? 'OER' : url === '/change-viewer/actioned' ? 'ACTER' : url === '/change-viewer/other-updates' ? 'OUER' : 'FUER';
  }

  async getUserProfile() {
    if (this._userService.userInfo && this._userService.userInfo.externalUserId && this._userService.userInfo.externalUserId !== '') {
      this.user = this._userService.userInfo;
      this.fetchUserJurisdiction();
    }
    else {
      this.user = await this._globalService.getLoginUserData();
      this._userService.userInfo = this.user;
      this.fetchUserJurisdiction();
    }
  }

  fetchUserJurisdiction(): void {
    this.columnSettings();

    if (this._userService.userJurisdiction.length > 0) {
      this.userJurisdiction = this._userService.userJurisdiction;
      this.setDivision();
      if (this.regulationFilter.ToDate) {

        if (this.checkGroupBy())
          this.getGroupData()
        else
          this.getRegulation();
      } else {
        this.getLatestPublishedDate();
      }
    }
    else {
      this.userService.getUserJurisdictions().subscribe((result: ItemIdModel[]) => {
        this.userJurisdiction = result; 
        this._userService.userJurisdiction = result;
        this.setDivision();
        if (this.regulationFilter.ToDate) {
          if (this.checkGroupBy())
            this.getGroupData()
          else
            this.getRegulation();
        } else {
          this.getLatestPublishedDate();
        }
      });
    }
    // this.userService.getUserJurisdictions().subscribe((result: ItemIdModel[]) => {
    //   this.userJurisdiction = result;
    //   this._userService.userJurisdiction=result;
    //   this.setDivision();
    //   if (this.regulationFilter.ToDate) {
    //     this.getRegulation();
    //   } else {
    //     this.getLatestPublishedDate();
    //   }
    // });

  }

  setDivision(): void {
    const persistFilter = JSON.parse(this.fetchFromBrowser(this.filterPersistenceKey) as string) as RegulationFilterModel;
    if (persistFilter) {
      this.regulationFilter.FilterType = persistFilter.FilterType;
      //this.regulationFilter.divisionId = persistFilter.divisionId;
      this.regulationFilter.divisionId = this.user.lastUsedJurisdictionId;
    } else {
      if (this.userJurisdiction && this.userJurisdiction.length > 0) {
        if (this.regulationFilter.divisionId === 0) {
          this.regulationFilter.divisionId = this.userJurisdiction[0].id;
        }
      } else {
        this.regulationFilter.divisionId = 0;
      }
    }
  }

  checkEditPermission(closedRegUsers: string[], jurisdiction: string, iaUsers: string[]): boolean | undefined {
    if (iaUsers && iaUsers.length > 0 && closedRegUsers.length === 0) {
      return false;
    } else {
      return this.checkJurisdictionPermission(jurisdiction);
    }
  }

  checkClosePermission(closedRegUsers: string[], jurisdiction: string, iaUsers: string[], isAssessed: boolean, isClosed: boolean): boolean {
    //Changing here for work item 273 - Soustav
    if (!isAssessed && !isClosed) {
      return true;
    }
    else if (isAssessed || isClosed) {
      return false;
    }
    else {
      return this.checkPermission(jurisdiction);
    }
  }

  checkPermission(jurisdiction: string): boolean {
    const commonItems = new Array<string>();
    if (jurisdiction) {
      this.userJurisdiction.forEach((element2) => {
        if (jurisdiction.toUpperCase() === element2.name.toUpperCase()) {
          commonItems.push(jurisdiction);
        }
      });
    };
    return commonItems.length > 0 ? false : true;
  }

  checkJurisdictionPermission(jurisdiction: string): boolean | undefined {
    if (jurisdiction) {
      const jurisArr = jurisdiction.split(',');
      const commonItems = new Array<string>();
      jurisArr.forEach((item) => {
        this.userJurisdiction.forEach((element2) => {
          if (item.toUpperCase() === element2.name.toUpperCase()) {
            commonItems.push(item);
          }
        });
      });
      return commonItems.length > 0 ? true : false;
    }
  }

  getLatestPublishedDate(): void {
    this.regulationService.getPublishedDate().subscribe((date: any) => {
      this.regulationFilter.ToDate = this.regulationFilter.ToDate ? this.regulationFilter.ToDate : date.message;
      if (this.checkGroupBy()) {
        this.isLoadingRegulations = false;
        if (this.clickedFilter != null || this.clickedFilter != "") {
          this.getPannelData(this.selectedPanelData, this.clickedFilter);
        }
        else {
          this.getPannelData(this.selectedPanelData);
        }
      }
      else
        this.getRegulation();
      this.selectedPanelName = [];
      this.clickedFilter = "";
    });
  }
  getLatestPublishedDateForBulkClose(): void {
    this.regulationService.getPublishedDate().subscribe((date: any) => {
      this.regulationFilter.ToDate = this.regulationFilter.ToDate ? this.regulationFilter.ToDate : date.message;
      if (this.checkGroupBy()) {
        this.isLoadingRegulations = false;
        if (this.selectedPanelName.length > 1) {
          this.getGroupData(true);
        }
        else {
          this.getPannelData(this.selectedPanelName.length > 0 ? this.selectedPanelName[0] : '');
        }
      }
      else
        this.getRegulation();
      this.selectedPanelName = [];
    });
  }

  filterSubType(search: string): any {
    return this.searchedSubType.filter((option) =>
      option.toLowerCase().includes(search.toLowerCase())
    );
  }

  filterSubTopic(search: string): any {
    return this.searchedSubTopic.filter((option) =>
      option.toLowerCase().includes(search.toLowerCase())
    );
  }

  async getRegulation(groupFilter?: any): Promise<void> {
    const url = this.router.url;

    this.regulationFilter.FilterType = url ? url === '/change-viewer/open'
      ? 'Open' : url === '/change-viewer/actioned' ? 'Actioned' : url === '/change-viewer/future-updates' ? 'Future Updates' : 'Other' : 'Open';
    this.selectedPubTypeSubFilters = [];
    this.regulationFilter.UserId = this.user.userId;
    this.isLoadingRegulations = true;

    if (this.regulationFilter.FilterType === 'Future Updates') {
      this.regulationFilter.FromDate = "";
      this.regulationFilter.ToDate = "";
    }
    if (this.regulationLibraryId > 0) {
      this.regulationFilter.regulationLibraryId = this.regulationLibraryId;
      this.regulationFilter.regulationLibraryType = this.regulationLibraryType;
      this.regulationFilter.FilterType = 'Other';
      this.sessionService.regLibraryId =
        this.regulationFilter.regulationLibraryId;
    }
    if (this.callingLocation == 'trendingDashboard') {
      this.trndingTopicsRegulationFilter.UserId = this.user.userId;
      this.trndingTopicsRegulationFilter.divisionId = this.regulationFilter.divisionId;
    }
    if (!this.regulationFilter.divisionId) {
      this.regulationFilter.divisionId = Number(localStorage.getItem('selectedDivision'));
    }


    // if (this.checkGroupBy() && !groupFilter) {
    //   this.groupingFilter.Country = this.regulationFilter.Country
    //   this.groupingFilter.DivisionId = this.regulationFilter.divisionId
    //   this.groupingFilter.FilterType = this.regulationFilter.FilterType
    //   this.groupingFilter.Filters = this.regulationFilter.Filters
    //   this.groupingFilter.FromDate = this.regulationFilter.FromDate
    //   this.groupingFilter.Geography = this.regulationFilter.Geography
    //   this.groupingFilter.IsTrendingDashboard = this.regulationFilter.IsTrendingDashboard
    //   this.groupingFilter.MappingID = this.regulationFilter.MappingID
    //   this.groupingFilter.RegulationId = this.regulationFilter.RegulationId
    //   this.groupingFilter.RegulationLibraryId = this.regulationFilter.regulationLibraryId
    //   this.groupingFilter.RegulationLibraryType = this.regulationFilter.regulationLibraryType
    //   this.groupingFilter.SearchQuery = this.regulationFilter.SearchQuery
    //   this.groupingFilter.Status = this.regulationFilter.Status
    //   this.groupingFilter.ToDate = this.regulationFilter.ToDate
    //   this.groupingFilter.UserId = this.regulationFilter.UserId
    //   // this.regulations.totalCount = null
    //   this.regulationService.GetGroupRegulatorUpdates(this.groupingFilter).subscribe((result: any) => {

    //     this.regulations.groupedData = result.length > 0 ? result : this.regulations.groupedData;
    //     this.isLoadingRegulations = false;
    //   })
    // }
    // else {

    const substringToCheck = '/change-viewer';
    if (url.includes(substringToCheck)) {
      this.regulationService.getRegulations(this.callingLocation == 'trendingDashboard' ? this.trndingTopicsRegulationFilter : this.regulationFilter, groupFilter, this.groupingFilter).subscribe((result: RegulationViewModel) => {
        localStorage.setItem('selectedDivision', this.regulationFilter.divisionId.toString());
        this.resultRegulations.data.subscribe((output) => {
          if (output.length > 0) {
            this.regulations.data = output;
          }
        });
        this.regulations.data = this.regulationFilter.Page > 1 ? this.regulations.data.concat(result.data) : result.data;
        // this.store.dispatch(addGroupData({ data: { pannelName: groupFilter, pannelData: this.regulations.data } }))
        this.regulations.totalCount = result.totalCount;

        this.resultRegulations.data.next(this.regulations.data);


        //For Assess
        //Convert below into a function
        if (this.resultRegulations != null) {
          this.processAssessData();
        }
        // const results = people.filter(element => {
        //   // 👇️ using AND (&&) operator
        //   return element.age === 30 && element.name === 'Carl';
        // });

        this.allRegulations = this.regulations.data;
        this.isLoadingRegulations = false;
        this.isRegulationFetched = true;
        if (this.regulations.data && this.regulations.data.length > 0) {
          this.myInnerHeight = window.innerHeight - 200;
          // this.regulations.data.forEach((item: RegulationModel) => {
          //   item.date = MasterHelper.formatDate(item.date, 'DD-MMM-YYYY').toString();
          // });


          // pubtype filtering before pagination implementation
          this.searchedSubType = Array.from(new Set(result.data.map((item: any) => item.pubType))).filter(function (e) {
            return e;
          });

          this.pubTypeSubFilters = Array.from(new Set(result.data.map((item: any) => item.pubType))).filter(function (e) {
            return e;
          });
          this.endIndex = (this.endIndex === 0 && this.regulations.totalCount > 13) ? 13 :
            (this.endIndex === 0 && this.regulations.totalCount <= 13) ? this.regulations.totalCount : this.endIndex;

          this.pubTypeSubCntrl.valueChanges.subscribe((term) => {
            this.searchedSubType = term ? this.filterSubType(term) : this.pubTypeSubFilters;
          });
          if (this.regulationFilter.regulationLibraryId > 0) {
            this.sessionService.libraryRegulation = this.regulations.totalCount;
            let libraryArrayIndex = this.regulationService.regulationLibrary.findIndex(x => x.id === this.regulationFilter.regulationLibraryId);
            if (libraryArrayIndex > -1) {
              this.regulationService.regulationLibrary[libraryArrayIndex].totalCount = this.regulations.totalCount;
            }

          } else {
            this.sessionService.libraryRegulation = 0;
            this.sessionService.regLibraryId = 0;
            if (this.regulationFilter.FilterType === 'Open') {
              this.sessionService.openRegulation = this.sessionService.openRegulation === -1 ? 0 : this.sessionService.openRegulation;
              this.sessionService.openRegulation = this.regulations.totalCount;
            } else if (this.regulationFilter.FilterType === 'Actioned') {
              this.sessionService.actionedRegulation =
                this.sessionService.actionedRegulation === -1 ? 0 : this.sessionService.actionedRegulation;
              this.sessionService.actionedRegulation = this.regulations.totalCount;
            } else if (this.regulationFilter.FilterType === 'Future Updates') {
              this.sessionService.futureRegulation =
                this.sessionService.futureRegulation === -1 ? 0 : this.sessionService.futureRegulation;
              this.sessionService.futureRegulation = this.regulations.totalCount;
            } else {
              this.sessionService.otherRegulation =
                this.sessionService.otherRegulation === -1 ? 0 : this.sessionService.otherRegulation;
              this.sessionService.otherRegulation = this.regulations.totalCount;
            }
          }
        } else {
          this.resetDataCount();
        }
      },
        (error: HttpErrorResponse) => {
          this.isLoadingRegulations = false;
          Logger.log(this.constructor.name, error.error);
        }
      );
      this.countFiltersItem();
    }
    // }
  }

  getGroupData(onfilter?: boolean) {
    this.isLoadingRegulations = true;
    let regulationId = this.groupingFilter.RegulationId
    const url = this.router.url;
    this.regulationFilter.FilterType = url ? url === '/change-viewer/open'
      ? 'Open' : url === '/change-viewer/actioned' ? 'Actioned' : url === '/change-viewer/future-updates' ? 'Future Updates' : 'Other' : 'Open';
    this.selectedPubTypeSubFilters = [];
    this.regulationFilter.UserId = this.user.userId;

    if (this.regulationFilter.FilterType === 'Future Updates') {
      this.regulationFilter.FromDate = "";
      this.regulationFilter.ToDate = "";
    }
    if (this.regulationLibraryId > 0) {
      this.regulationFilter.regulationLibraryId = this.regulationLibraryId;
      this.regulationFilter.regulationLibraryType = this.regulationLibraryType;
      this.regulationFilter.FilterType = 'Other';
      this.sessionService.regLibraryId =
        this.regulationFilter.regulationLibraryId;
    }
    if (this.callingLocation == 'trendingDashboard') {
      this.trndingTopicsRegulationFilter.UserId = this.user.userId;
      this.trndingTopicsRegulationFilter.divisionId = this.regulationFilter.divisionId;
    }
    if (!this.regulationFilter.divisionId) {
      this.regulationFilter.divisionId = Number(localStorage.getItem('selectedDivision'));
    }
    this.groupingFilter.Country = this.regulationFilter.Country
    this.groupingFilter.DivisionId = this.regulationFilter.divisionId
    this.groupingFilter.FilterType = this.regulationFilter.FilterType
    this.groupingFilter.Filters = this.regulationFilter.Filters
    this.groupingFilter.FromDate = this.regulationFilter.FromDate
    this.groupingFilter.Geography = this.regulationFilter.Geography
    this.groupingFilter.IsTrendingDashboard = this.regulationFilter.IsTrendingDashboard
    this.groupingFilter.MappingID = this.regulationFilter?.MappingID ? this.regulationFilter?.MappingID : [];
    this.groupingFilter.RegulationId = this.regulationFilter.RegulationId
    this.groupingFilter.RegulationLibraryId = this.regulationFilter.regulationLibraryId
    this.groupingFilter.RegulationLibraryType = this.regulationFilter.regulationLibraryType
    this.groupingFilter.SearchQuery = this.regulationFilter.SearchQuery
    this.groupingFilter.Status = this.regulationFilter.Status ? this.regulationFilter.Status : []
    this.groupingFilter.ToDate = this.regulationFilter.ToDate
    this.groupingFilter.UserId = this.user.userId;
    this.groupingFilter.IsSimilarId = this.regulationFilter.IsSimilarId;
    this.groupingFilter.SimilarIdFor = this.regulationFilter.SimilarIdFor;
    //this.groupingFilter.GroupBy = "MappingId";
    this.groupingFilter.GroupBy = this.groupBy;
    this.isFirstTimeLoad = false;
    // this.regulations.totalCount = null
    this.store.select(getGroupData).pipe(first()).subscribe(res => {
      if (this.groupFilterType === this.groupingFilter.FilterType && regulationId == this.groupingFilter.RegulationId && !onfilter) {
        this.groupData = JSON.parse(JSON.stringify(res));
        this.searchFilterFormList = this.groupData.map(e => e.groupByColumnData);
        this.isFirstTimeLoad = true;
        this.isLoadingRegulations = false
      }
      else {
        this.regulationService.GetGroupRegulatorUpdates(this.groupingFilter).subscribe((result: GroupingRegulationViewModel[]) => {
          let groupstates = result.map(e => {
            return {
              ...e,
              pannelData: [],
              panelOpenState: false,
              pageIndex: 0,
              pageSize: 10,
              isActionDone: false,
              groupByColumnData: e.groupByColumnData,
              otherDataSummary: e.otherDataSummary,
              totalCount: e.totalCount,
              isPanelIdSelected: false,
              lastSelected: 0,
              totalSelectedRow: 0,
              isLoading: false,
              activeItemCount: 0,
            } as GroupState;
          });

          // groupstates.forEach(e => {
          //   e.otherDataSummary = JSON.parse('[' + e.otherDataSummary + ']')
          // })
          this.groupData = JSON.parse(JSON.stringify(groupstates));
          this.searchFilterFormList = this.groupData.map(e => e.groupByColumnData);
          this.store.dispatch(setGroupData({ data: groupstates }));
          this.store.dispatch(updateFilterType({ data: this.groupingFilter.FilterType }));
          // this.regulations.groupedData = result.length > 0 ? result : this.regulations.groupedData;
          this.searchFilter();

          this.isLoadingRegulations = false;
        })
      }
    })


  }
  applyFilter(event: { input: any; value: any; }) {
    if (!this.searchFilterInput.isOpen) {
      const input = event.input;
      const value = event.value;
      if ((value || '').trim()) {
        this.store.dispatch(updateFilter({ data: [...this.groupFilter, value.trim()] }))
      }
      if (input)
        input.value = ''
      this.searchFilterFormControl.setValue(null)
    }
  }
  selectApplyFilter(event: { option: { viewValue: any; }; }) {
    const value = event.option.viewValue;

    if ((value || '').trim()) {
      this.store.dispatch(updateFilter({ data: [...this.groupFilter, value.trim()] }));

    }
    this.searchFilterFormControl.setValue(null)
  }

  removeFromFilter(type: string) {
    const index = this.groupFilter.indexOf(type);

    if (index >= 0) {
      this.groupFilter.splice(index, 1);
      this.store.dispatch(updateFilter({ data: this.groupFilter }));

    }
  }

  searchFilter() {
    this.filteredGroupData = [];
    if (this.groupFilter.length > 0) {
      this.groupFilter.forEach(item => {

        let filteredItems = this.groupData.filter(e => e.groupByColumnData.toLowerCase().includes(item.toLowerCase()))
        this.filteredGroupData = [...this.filteredGroupData, ...filteredItems]
      })
    }
    else
      this.filteredGroupData = this.groupData;
    this.store.dispatch(updateGroupPagination({ data: 0 }))
  }




  updatePannelOpenState(pannelName: string, data: boolean, pannelDataLength?: number) {
    this.groupData[this.groupData.findIndex(i => i.groupByColumnData === pannelName)].panelOpenState = data
    this.store.dispatch(updatePannelOpenState({ data: data, groupByColumnData: pannelName }))
    if (data && pannelDataLength == 0)
      this.getPannelData(pannelName)
  }
  getPannelOpenState(pannelName: string) {
    return this.store.select(getPannelOpenState(pannelName))
  }
  getPannelDataLength(pannelName: string): number | void {
    this.store.select(getPannelDataLength(pannelName)).subscribe(res => {

      return res;
    })
  }

  getPannelData(pannelName: string, clickFilter?: string | undefined) {
    this.groupData[this.groupData.findIndex(i => i.groupByColumnData === pannelName)].isLoading = true;

    this.store.select(getPannelPagination(pannelName)).pipe(first()).subscribe(res => {
      this.regulationFilter.PageSize = res.pageSize ? res.pageSize : 10
      this.regulationFilter.Page = res.pageIndex ? res.pageIndex + 1 : 0 + 1
    })

    this.regulationService.getRegulations(this.regulationFilter, pannelName, this.groupBy, clickFilter).subscribe(res => {
      res.data.forEach(item => {
        if (this.regulationFilter.FilterType !== 'Actioned'
          && this.regulationFilter.FilterType !== 'Other'
          && this.commonService.checkPlanTypeAction(this.cCode)) {
          item.isRowBold = true;
        }
        else if ((this.regulationFilter.FilterType === 'Other' || this.regulationLibraryType > 0)
          && (this.checkClosePermission(item.closedRegulationUsers, item.jurisdiction, item.impactAssessmentUsers, item.isAssessed, item.isClosed))
          && this.commonService.checkPlanTypeAction(this.cCode)) {
          item.isRowBold = true;
        }
        else if ((this.regulationFilter.FilterType === 'Other') && !this.checkPermission(item.jurisdiction)
          && this.commonService.checkPlanTypeAction(this.eCode)) {
          if (this.checkClosePermission(item.closedRegulationUsers, item.jurisdiction, item.impactAssessmentUsers, item.isAssessed, item.isClosed)) {
            item.isRowBold = false;
          }
          if (!this.checkClosePermission(item.closedRegulationUsers, item.jurisdiction, item.impactAssessmentUsers, item.isAssessed, item.isClosed)) {
            item.isRowBold = false;
          }
        }
      });
      this.groupData[this.groupData.findIndex(i => i.groupByColumnData === pannelName)].activeItemCount = res.totalCount;

      if ((this.regulationFilter.SortKey != null && this.regulationFilter.SortKey != "") && this.regulationFilter.Page == 1) {
        this.store.dispatch(setPannelData({ data: res.data, pannelName: pannelName }))
        if (this.groupData.findIndex(i => i.groupByColumnData === pannelName) >= 0)
          this.groupData[this.groupData.findIndex(i => i.groupByColumnData === pannelName)].pannelData = res.data;
        if (this.isFirstTimeLoad) {
          this.filteredGroupData = this.groupData;
          this.groupData[this.groupData.findIndex(i => i.groupByColumnData === pannelName)].isLoading = false;
        }
        else {
          this.groupData[this.groupData.findIndex(i => i.groupByColumnData === pannelName)].isLoading = false;
        }
      }
      else {
        let panelLength = this.groupData[this.groupData.findIndex(i => i.groupByColumnData === pannelName)].activeItemCount;
        if (this.groupData[this.groupData.findIndex(i => i.groupByColumnData === pannelName)].pannelData.length < panelLength) {
          this.store.dispatch(addPannelData({ data: res.data, pannelName: pannelName }))
          this.groupData[this.groupData.findIndex(i => i.groupByColumnData === pannelName)].pannelData = Object.assign([], this.groupData[this.groupData.findIndex(i => i.groupByColumnData === pannelName)].pannelData);
          this.groupData[this.groupData.findIndex(i => i.groupByColumnData === pannelName)].pannelData.push(...res.data);
          this.groupData[this.groupData.findIndex(i => i.groupByColumnData === pannelName)].isLoading = false;
        }
        else {
          this.groupData[this.groupData.findIndex(i => i.groupByColumnData === pannelName)].isLoading = false;
        }

      }

      // this.store.dispatch(addPannelData({ data: res.data, pannelName: pannelName }))
      // this.groupData[this.groupData.findIndex(i => i.groupByColumnData === pannelName)].pannelData.push(...res.data)
    })

  }

  getFilterPannelDataSize(pannel: { clickFilter: any; pannelData: { filter: (arg0: (e: any) => boolean) => { (): any; new(): any; length: any; }; }; totalCount: any; }) {
    return pannel.clickFilter ?
      pannel.pannelData.filter((e: { pubType: any; mappingID: any; }) => (this.groupBy === 'MappingId' ? pannel.clickFilter === e.pubType : pannel.clickFilter === e.mappingID)).length
      : pannel.totalCount
  }

  groupingPagination(pannelName: string, e: { pageSize: number; pageIndex: number; }, pannelIndex: any, clickFilter: any) {
    this.groupData[this.groupData.findIndex(i => i.groupByColumnData === pannelName)].pageSize = e.pageSize;
    this.groupData[this.groupData.findIndex(i => i.groupByColumnData === pannelName)].pageIndex = e.pageIndex;
    this.store.dispatch(updatePannelPagination({ data: { pageIndex: e.pageIndex, pageSize: e.pageSize }, groupByColumnData: pannelName }))
    this.store.select(getPannelDataLength(pannelName)).pipe(first()).subscribe(res => {
      if (res) {
        if (e.pageSize * (e.pageIndex + 1) > res)
          this.getPannelData(pannelName, clickFilter);
      }

    })
    this.filteredGroupData[pannelIndex].isPanelIdSelected = false;
  }
  pannelPaginaation(e: { pageIndex: number; }) {
    this.groupPageIndex = e.pageIndex;
    this.store.dispatch(updateGroupPagination({ data: e.pageIndex }));
  }


  resetDataCount(): void {
    this.myInnerHeight = 0;
    if (this.regulationFilter.FilterType === 'Open') {
      this.sessionService.openRegulation = 0;
    } else if (this.regulationFilter.FilterType === 'Actioned') {
      this.sessionService.actionedRegulation = 0;
    } else if (this.regulationFilter.FilterType === 'Future Updates') {
      this.sessionService.futureRegulation = 0;
    } else {
      this.sessionService.otherRegulation = 0;
    }
    if (this.regulationFilter.regulationLibraryId > 0) {
      this.sessionService.libraryRegulation = 0;
    }
  }

  async downloadRegulations(): Promise<any> {
    const filter = MasterHelper.parseRegulationFilters(this.regulationFilter);
    this.isDownloading = true;
    this.regulationService.downloadRegulations(filter).subscribe(
      (data: any) => {
        this.isDownloading = false;
        // tslint:disable-next-line:one-variable-per-declaration
        const a = document.createElement('a'),
          fileURL = URL.createObjectURL(data);
        a.href = fileURL;
        a.download = `Regulations_${MasterHelper.getCurrrentDateTime(
          'MMDDYYYYHHMMSS'
        )}.xlsx`;
        window.document.body.appendChild(a);
        a.click();
        window.document.body.removeChild(a);
      },
      (error: HttpErrorResponse) => {
        this.isDownloading = false;
        Logger.log(this.constructor.name, error.error);
      }
    );
  }

  sortRegulations(key: string): void {
    this.regulationFilter.IsDesc = !this.regulationFilter.IsDesc;
    this.regulationFilter.SortKey = key;
    this.regulationFilter.Page = 1;
    this.resultRegulations = new RegulationResultModel();
    this.resetDataCount();
    this.getRegulation();
    this.IsRowEdited();

  }

  sortGroupRegulations(pannelName: any, key: string): void {
    this.regulationFilter.IsDesc = !this.regulationFilter.IsDesc;
    this.regulationFilter.SortKey = key;
    this.regulationFilter.Page = 1;
    this.resetDataCount();
    this.getPannelData(pannelName);
  }

  OnFilter(filter: { regulationFilter: RegulationFilterModel, groupingFilter: GroupingModel }): void {
    this.endIndex = 0;
    this.filterDropDown.hide();
    this.regulationFilter = filter.regulationFilter;
    this.groupingFilter = filter.groupingFilter;

    this.store.dispatch(updateGroupBy({ data: filter.groupingFilter.GroupBy }));
    this.regulationFilter.Page = 1;
    this.resultRegulations = new RegulationResultModel();
    this.resetDataCount();
    if (this.checkGroupBy())
      this.getGroupData(true);
    else
      this.getRegulation();
    this.IsRowEdited();
    this.countFiltersItem();
  }

  calculatePagination(): void {
    if (this.regulationFilter.TakeCount) {
      const pageCount = Math.ceil(
        this.regulations.totalCount / this.regulationFilter.TakeCount
      );
      this.totalPageCount = pageCount;
    }
  }

  saveOnBrowser(key: string, value: string): void {
    localStorage.setItem(key, value);
  }

  fetchFromBrowser(key: string): any {
    return localStorage.getItem(key);
  }

  removeFromBrowser(key: string): any {
    return localStorage.removeItem(key);
  }

  handler(): void {
    this.endIndex = this.viewport.getRenderedRange().end;
    if ((this.endIndex % 50) === 0 && (this.endIndex / 50) === this.regulationFilter.Page) {
      this.regulationFilter.Page = this.regulationFilter.Page + 1;
      this.getRegulation();
    }
  }

  getFilteredRegulations(): void {
    this.regulations.data = this.allRegulations;
    this.regulations.totalCount = this.regulations.data.length;
    const searchedResult = Array<RegulationModel>();
    if (this.selectedPubTypeSubFilters.length > 0) {
      this.allRegulations.forEach((element) => {
        this.selectedPubTypeSubFilters.forEach((element2) => {
          if (
            element.pubType &&
            element.pubType.toUpperCase().includes(element2.toUpperCase())
          ) {
            searchedResult.push(element);
          }
        });
      });
      this.regulations.data = searchedResult;
    }
    this.regulations.totalCount = this.regulations.data.length;
    this.endIndex =
      this.endIndex > this.regulations.totalCount
        ? this.regulations.totalCount
        : this.endIndex;
  }

  toggleClass(event: any, itemClass: string): void {
    if (event) {
      const hasClass = event.target.classList.contains(itemClass);
      if (hasClass) {
        event.target.classList = '';
      } else {
        event.target.classList = itemClass;
      }
    }
  }

  removeSubType(type: string): void {
    const index = this.selectedPubTypeSubFilters.indexOf(type);

    if (index >= 0) {
      this.selectedPubTypeSubFilters.splice(index, 1);
    }
    this.getFilteredRegulations();
  }

  addSubType(event: MatChipInputEvent): void {
    if (this.pubTypeSubAutocomplete && !this.pubTypeSubAutocomplete.isOpen) {
      const input = event.input;
      const value = event.value;
      if ((value || '').trim()) {
        this.selectedPubTypeSubFilters.push(value);
      }
      // Reset the input value
      if (input) {
        input.value = '';
      }
      this.pubTypeSubCntrl.setValue(null);
      this.pubTypeSubCntrl.disable();
      this.pubTypeSubCntrl.enable();
      this.getFilteredRegulations();
    }
  }

  selectSubType(event: MatAutocompleteSelectedEvent): void {
    if (this.selectedPubTypeSubFilters) {
      this.selectedPubTypeSubFilters.push(event.option.viewValue);
    } else {
      this.selectedPubTypeSubFilters = [];
      this.selectedPubTypeSubFilters.push(event.option.viewValue);
    }
    this.pubTypeSubInput.nativeElement.value = '';
    this.pubTypeSubCntrl.setValue(null);
    this.pubTypeSubCntrl.disable();
    this.pubTypeSubCntrl.enable();
    this.getFilteredRegulations();
  }

  openDialog(item: RegulationModel, filtertype: string, panelName: string, smallPanel: string, pIndex: number): void {
    let myValue = "Bigpanel";
    if (smallPanel == '' || smallPanel == null || smallPanel == undefined) {
      smallPanel = myValue;
    }
    this.selectedPanelData = panelName;
    if (item.regulationDetails) {
      this.regulationDetail = item.regulationDetails;
    } else {
      this.regulationDetail.regulationId = item.id;
    }
    this.regulationDetail.filterType = filtertype;
    this.regulationDetail.title = item.title;
    this.regulationDetail.type = item.pubType;
    this.regulationDetail.similarIndex = item.similarityIndex;
    const dialogRef = this.dialog.open(ChangeViewerDialogComponent, {
      width: '1000px',
      data: this.regulationDetail,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'Delete Regulation Details') {
        if (this.checkGroupBy()) {
          this.getPannelData(this.selectedPanelData);
        }
        else {
          this.getRegulation();
        }
      } else if (result) {
        if (this.checkGroupBy()) {
          if (this.selectedPanelName.length < 1) {
            this.selectedPanelName.push(panelName);
          }
          if (smallPanel == "Bigpanel") {
            this.filteredGroupData[pIndex].isActionDone = true;
          }
          else {
            this.clickedFilter = smallPanel;
            this.filteredGroupData[pIndex].isActionDone = true;
            let panelInnerName = this.filteredGroupData[pIndex].otherDataSummary.find((x: { mappingIdOrPubType: string; }) => x.mappingIdOrPubType == smallPanel);
            panelInnerName.isActioned = true;
          }
          //######################################
          // ActionDone for Close Action Fix for normal view
          //######################################
        }
        if (this.regulationDetail.id === 0 && result.selectedLinkedIds && result.selectedLinkedIds.length > 0) {
          result.selectedLinkedIds.push(item.id);
          this.bulkCloseRegulations(result, 'Close');
        } else {
          //######################################
          this.updateRegulationDetail(result, item.id);
        }
      } else {
        this.regulationDetail = new RegulationDetail();
      }
    });
  }

  updateRegulationDetail(regulation: RegulationDetail, id: number): void {
    this.selectedItems = [];
    this.isLoadingRegulations = true;
    regulation.regulationId = !regulation.regulationId ? id : regulation.regulationId;
    regulation.isRead = true;
    regulation.status = +regulation.status;
    this.regulationService.updateRegulationInfo(regulation).subscribe((result: any) => {
      this.selectedItems.push(id);
      this.saveOnBrowser('_iadid', JSON.stringify(this.selectedItems));
      if (result.message === 'Saved Successfully') {
        this.successAlert(result.message);
      } else {
        this.warningAlert(result.message);
      }
      this.selectedItems = [];
      this.selectedPanelName = [];
      this.regulationFilter.Page = 1;
      this.regulationFilter.PageSize = 50;
      this.getLatestPublishedDate();
    });
  }

  // getRegulationStatus(num: number): any {
  //   return RegulatorStatusLabel.get(num);
  // }

  checkTransferedItems(id: number): any {
    if (this.newIAAItemIdList.length > 0) {
      const index = (this.newIAAItemIdList as number[]).indexOf(id);
      return index >= 0 ? true : null;
    }
  }

  selectAllItem(event: any): void {
    if (event === 'Checked') {
      let regArray: any[] = [];
      this.resultRegulations.data.subscribe((result) => {
        regArray = result;
      });
      regArray.forEach((item) => {
        this.selectedItems.push(item.id);
        if (item.impactAssessmentUsers != null && item.impactAssessmentUsers.length > 0) {
          this.actionedIds.push(item.id);
        }
        if (item.closedRegulationUsers != null && item.closedRegulationUsers.length > 0) {
          this.actionedIds.push(item.id);
        }
      });
    } else {
      this.selectedItems = [];
      this.actionedIds = [];
    }
  }
  selectAllPannelItem(event: any, pannel: GroupState, pannelIndex: any): void {
    let panelName = this.filteredGroupData[pannelIndex].groupByColumnData;
    if (event === 'Checked') {
      pannel.pannelData.forEach((item, index) => {
        if (!pannel.clickFilter || (this.groupBy === 'MappingId' ? pannel.clickFilter === item.pubType : pannel.clickFilter === item.mappingID)) {
          let isRowPresent = this.selectedItems.filter(
            x => x === item.id);
          let isActioned = this.actionedIds.filter(x => x === item.id);
          if (isRowPresent.length == 0) {
            if (index >= (pannel.pageIndex * pannel.pageSize) && index < ((pannel.pageIndex + 1) * pannel.pageSize)) {
              this.selectedItems.push(item.id);
              if (item.closedRegulationUsers?.length > 0) {
                if (isActioned.length == 0) {
                  this.actionedIds.push(item.id);
                }
              }
              if (item.impactAssessmentUsers?.length > 0) {
                if (isActioned.length == 0) {
                  this.actionedIds.push(item.id);
                }
              }
            }
          }
        }
      })
      let isPanelPresent = this.selectedPanelName.filter(x => x === panelName);
      if (isPanelPresent.length == 0) {
        this.selectedPanelName.push(panelName);
      }
      this.filteredGroupData[pannelIndex].isPanelIdSelected = true;
    } else {
      pannel.pannelData.forEach((item, index) => {
        // if (index >= (pannel.pageIndex * pannel.pageSize) && index < ((pannel.pageIndex + 1) * pannel.pageSize))
        // {

        // }
        let selectedItemIndex = this.selectedItems.findIndex(x => x === item.id);
        let actionItemIndex = this.actionedIds.findIndex(x => x === item.id);
        if (selectedItemIndex >= 0)
          this.selectedItems.splice(selectedItemIndex, 1);
        if (actionItemIndex >= 0) {
          this.actionedIds.splice(actionItemIndex, 1);
        }
        const panelIndex = (this.selectedPanelName as string[]).indexOf(panelName);
        if (panelIndex >= 0) {
          (this.selectedPanelName as string[]).splice(panelIndex, 1);
        }
      })
      this.filteredGroupData[pannelIndex].isPanelIdSelected = false;
    }
  }


  selectItem(event: any, id: number, e: { shiftKey: any; }, index: number, assessId: any, closeId: any): void {
    if (e.shiftKey) {
      this.selectRowsFill(index, event);
    } else {
      this.selectElement(event, id, index, assessId, closeId); // As does this call.
    }
  }
  selectElement(event: any, id: any, index: number, assessId: any, closeId: any) {
    if (event === 'Checked') {
      this.selectedItems.push(id);
      if (assessId != null && assessId.length > 0) {
        this.actionedIds.push(id);
      }
      if (closeId != null && closeId.length > 0) {
        this.actionedIds.push(id);
      }
    } else {
      const index = (this.selectedItems as number[]).indexOf(id);
      const actionIndex = (this.actionedIds as number[]).indexOf(id);
      if (index >= 0) {
        (this.selectedItems as number[]).splice(index, 1);
      }
      if (actionIndex >= 0) {
        (this.actionedIds as number[]).splice(index, 1);
      }
    }
    this.lastSelected = index;
  }
  selectRowsFill(index: number, selectEvent: any) {
    this.selectedItems = [];
    const indexA = this.lastSelected;
    const indexB = index;
    let regArray: any[] = [];
    this.resultRegulations.data.subscribe((result) => {
      regArray = result;
    });
    if (indexA > indexB) {
      for (let i = indexB; i <= indexA; i++) {
        this.selectElement(selectEvent, regArray[i].id, i, regArray[i].impactAssessmentUsers, regArray[i].closedRegulationUsers);
      }
    } else {
      for (let i = indexA; i <= indexB; i++) {
        this.selectElement(selectEvent, regArray[i].id, i, regArray[i].impactAssessmentUsers, regArray[i].closedRegulationUsers);
      }
    }
  }
  selectPanelItem(event: any, id: number, e: { shiftKey: any; }, index: number, pannelIndex: number, selectedCountry: string, selectedRegulator: string, selectedPub: string, isClosedId: any, isAssessedId: any): void {
    if (e.shiftKey) {
      this.selectPanelRowsFill(index, event, pannelIndex, selectedCountry, selectedRegulator, selectedPub);
    } else {
      this.selectPanelElement(event, id, index, pannelIndex, selectedCountry, selectedRegulator, selectedPub, isClosedId, isAssessedId); // As does this call.
    }
  }
  selectPanelElement(event: any, id: number, index: number, pannelIndex: number, selectedCountry: string, selectedRegulator: string, selectedPub: string, isClosedId: any, isAssessedId: any) {
    let groupByName = this.groupingFilter.GroupBy;
    let panelName = this.filteredGroupData[pannelIndex].groupByColumnData;
    let smallPanel = "";
    if (groupByName == "Country" || groupByName == "PubType") {
      smallPanel = selectedCountry + " : " + selectedRegulator;
    }
    if (groupByName == "MappingId") {
      smallPanel = "" + selectedPub + "";
    }

    if (event === 'Checked') {
      let isRowPresent = this.selectedItems.filter(
        x => x === id);
      let isActioned = this.actionedIds.filter(x => x === id);
      if (isRowPresent.length == 0) {
        this.selectedItems.push(id);
        if (isClosedId?.length > 0) {
          if (isActioned.length == 0) {
            this.actionedIds.push(id);
          }
        }
        if (isAssessedId?.length > 0) {
          if (isActioned.length == 0) {
            this.actionedIds.push(id);
          }
        }
        let isSmallPanelPresent = this.selectedSubPanelName.filter(x => x === smallPanel);
        if (isSmallPanelPresent.length == 0) {
          this.selectedSubPanelName.push(smallPanel);
        }
        let isPanelPresent = this.selectedPanelName.filter(
          x => x === panelName);
        if (isPanelPresent.length == 0) {
          this.selectedPanelName.push(panelName);
        }
      }
    } else {
      const index = (this.selectedItems as number[]).indexOf(id);
      const actionIndex = (this.actionedIds as number[]).indexOf(id);
      if (index >= 0) {
        (this.selectedItems as number[]).splice(index, 1);
      }
      if (actionIndex >= 0) {
        (this.actionedIds as number[]).splice(actionIndex, 1);
      }
      const panelIndex = (this.selectedPanelName as string[]).indexOf(panelName);
      if (panelIndex >= 0) {
        (this.selectedPanelName as string[]).splice(panelIndex, 1);
      }
      const smallPanelIndex = (this.selectedSubPanelName as string[]).indexOf(smallPanel);
      if (smallPanelIndex >= 0) {
        (this.selectedSubPanelName as string[]).splice(smallPanelIndex, 1);
      }
    }
    this.filteredGroupData[pannelIndex].lastSelected = index;
    this.lastSelectedPanel = pannelIndex;
    // this.lastSelectedSmallPanel = smallPanelIndex;
  }

  getSelectedPannelItems(pannelData: any[]) {
    let selectedItemLength = 0;
    pannelData.forEach(item => {
      if (this.selectedItems.includes(item.id))
        selectedItemLength++
    });
    return selectedItemLength
  }

  selectPanelRowsFill(index: number, selectEvent: any, pannelIndex: number, selectedCountry: string, selectedRegulator: string, selectedPub: string) {
    if (this.lastSelectedPanel == pannelIndex || this.selectedItems.length == 0) {
      const indexA = this.filteredGroupData[pannelIndex].lastSelected;
      const indexB = index;
      if (indexA > indexB) {
        for (let i = indexB; i <= indexA; i++) {
          this.selectPanelElement(selectEvent, this.filteredGroupData[pannelIndex]?.pannelData[i]?.id, i, pannelIndex, selectedCountry, selectedRegulator, selectedPub, this.filteredGroupData[pannelIndex]?.pannelData[i]?.closedRegulationUsers, this.filteredGroupData[pannelIndex]?.pannelData[i]?.impactAssessmentUsers);
        }
      } else {
        for (let i = indexA; i <= indexB; i++) {
          this.selectPanelElement(selectEvent, this.filteredGroupData[pannelIndex]?.pannelData[i]?.id, i, pannelIndex, selectedCountry, selectedRegulator, selectedPub, this.filteredGroupData[pannelIndex]?.pannelData[i]?.closedRegulationUsers, this.filteredGroupData[pannelIndex]?.pannelData[i]?.impactAssessmentUsers);
          // this.selectedItems.push(regArray[i].id);
        }
      }
    }
  }

  getSelectedItems(id: number): boolean {
    const index = (this.selectedItems as number[]).indexOf(id);
    return index >= 0 ? true : false;
  }

  bulkClose(): void {
    if (this.selectedItems.length > 0) {
      this.openBulkCloseDialog();
    } else {
      this.warningAlert('Please select at least one');
    }
  }

  openBulkCloseDialog(): void {
    const dialogRef = this.dialog.open(BulkCloseDialogComponent, {
      width: '750px',
      data: this.selectedItems
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.bulkCloseRegulations(result, 'BulkClose');
      }
    });
  }

  bulkCloseRegulations(regDetails: RegulationDetail, filter: string): void {
    this.isLoadingRegulations = true;
    this.bulkCloseData.itemIds = filter === 'BulkClose' ? this.selectedItems : regDetails.selectedLinkedIds;
    regDetails.userId = this.user.externalUserId;
    regDetails.isRead = true;
    this.bulkCloseData.regulationDetail = regDetails;
    if (this.bulkCloseData.itemIds && this.bulkCloseData.itemIds.length > 50) {
      this.warningAlert('This operation may take a while to complete. The page will refresh upon completion. Please wait...');
    }
    this.bulkCloseData.regulationDetail.title = '';
    this.regulationService.regulationBulkClose(this.bulkCloseData).subscribe((result: any) => {
      this.saveOnBrowser('_iadid', JSON.stringify(this.selectedItems));
      if (result.message === 'Saved Successfully') {
        this.successAlert(result.message);
        //Following code for highlighting the panel where close have been attempted.
        this.selectedPanelName.forEach(item => {
          let panel = this.filteredGroupData.find((x: { groupByColumnData: string; }) => x.groupByColumnData == item);
          if (panel != null) {
            panel.isActionDone = true;
            this.selectedSubPanelName.forEach(items => {
              let isSubPanel = panel.otherDataSummary.find((x: { mappingIdOrPubType: string; }) => x.mappingIdOrPubType == items);
              if (isSubPanel != null) {
                panel.otherDataSummary.find((x: { mappingIdOrPubType: string; }) => x.mappingIdOrPubType == items).isActioned = true;
              }
            });
          }
        });
      } else {
        this.warningAlert(result.message);
      }
      this.selectedItems = [];
      this.actionedIds = [];
      this.selectedSubPanelName = [];
      this.bulkCloseData = new BulkCloseModel();
      this.regulationFilter.Page = 1;
      this.regulationFilter.PageSize = 50;
      this.getLatestPublishedDateForBulkClose();
      //this.getLatestPublishedDate();
    });
  }

  warningAlert(msg: string): void {
    this.toastModel.Title = 'Warning';
    this.toastModel.Type = 'warning';
    this.toastModel.Message = msg;
    this.isToastShow = true;
    setTimeout(() => {
      this.isToastShow = false;
    }, 5000);
  }

  successAlert(msg: string): void {
    this.toastModel.Title = 'Success';
    this.toastModel.Type = 'success';
    this.toastModel.Message = msg;
    this.isToastShow = true;
    setTimeout(() => {
      this.isToastShow = false;
    }, 5000);
  }

  openPopUp(id: number, item: RegulationModel, panelName: string, smallPanel: string, pIndex: number): void {
    
    this.selectedPanelData = panelName;
    if (item.regulationDetails) {
      this.regulationDetail = item.regulationDetails;
    } else {
      this.regulationDetail.regulationId = item.id;
    }
    // this.regulationDetail.filterType = filtertype;
    this.regulationDetail.title = item.title;
    this.regulationDetail.type = item.pubType;
    this.regulationDetail.similarIndex = item.similarityIndex;
    this.userService.getUserJurisdictions().subscribe((result: ItemIdModel[]) => {
      if (result && result.length === 1) {
        const selectedJuridiction = MasterHelper.getStringArrayFromObjectArray(result);
        this.addImpactAssessment(selectedJuridiction, id);
      }
      else {
        if (this.regulationDetail.similarIndex != '') {
          let searchedId = localStorage.getItem('selectedDivision');
          if (searchedId) {
            this.selectedItemId = id;
            const dialogRef = this.dialog.open(JurisdictionDialogComponent, {
              width: '1000px',
              // data: result
              data: { result: result, regulationDetails: this.regulationDetail, type: "assess" }
            });
            dialogRef.afterClosed().subscribe((response) => {
              
              if (response) {
                //######################################
                // ActionDone for Assess Action Fix for normal view
                //######################################
                if (this.checkGroupBy()) {
                  if (this.selectedPanelName.length < 1) {
                    this.selectedPanelName.push(panelName);
                  }
                  //######################################
                  if (smallPanel == '' || smallPanel == null) {
                    this.filteredGroupData[pIndex].isActionDone = true;
                  }
                  else {
                    this.clickedFilter = smallPanel;
                    this.filteredGroupData[pIndex].isActionDone = true;
                    let panelInnerName = this.filteredGroupData[pIndex].otherDataSummary.find((x: { mappingIdOrPubType: string; }) => x.mappingIdOrPubType == smallPanel);
                    panelInnerName.isActioned = true;
                  }
                }
                if (this.regulationDetail.id === 0 && response.regulationDetails.selectedLinkedIds && response.regulationDetails.selectedLinkedIds.length > 0) {

                  response.regulationDetails.selectedLinkedIds.unshift(item.id);
                  this.selectedItems = response.regulationDetails.selectedLinkedIds;
                  // this.bulkCloseRegulations(response.regulationDetails, 'Close');
                  this.addMergeAssessment();
                }
                else {
                  this.addImpactAssessment(response.result, this.selectedItemId);
                }
              } else {
                this.selectedItemId = 0;
              }
            });
          }
        }
        else {
          let searchedId = localStorage.getItem('selectedDivision');
          var filterDivision = result.filter(s => s.id.toString() == searchedId);
          if (filterDivision && filterDivision.length > 0) {
            this.addImpactAssessment([filterDivision[0].name], id);
          }
          else {
            this.addImpactAssessment([result[0].name], id);
          }
        }
      }
    });
  }

  addImpactAssessment(jurisdictions: Array<string>, id: number): void {
    
    const itemInfoDto = new ItemInfoDto();
    itemInfoDto.id = id;
    itemInfoDto.screenUrl = this.router.url;
    itemInfoDto.jurisdictions = jurisdictions;
    this.isLoadingRegulations = true;
    this.gdprService.getTemplateNo().subscribe((data: any) => {
      this.templateNo = data.result;
      itemInfoDto.templateNo = this.templateNo;
      if (this.templateNo == 4) {
        this.gdprService.moveToImpactAssessment4(itemInfoDto).subscribe((data: any) => {
          this.selectedItemId = 0;
          this.isLoadingRegulations = false;
          this.getAlertMessage(data);
          // if (this.checkGroupBy()) {
          //   if (this.clickedFilter != null || this.clickedFilter != "") {
          if (this.checkGroupBy()) {
            if (this.clickedFilter != null || this.clickedFilter != "") {
              this.getPannelData(this.selectedPanelData, this.clickedFilter);
            }
            else {
              this.getPannelData(this.selectedPanelData);
            }
          }
          else {
            this.getRegulation();
          }
          this.selectedPanelName = [];
          this.selectedItems = [];
          this.clickedFilter = "";
        });
      }
      else if(this.templateNo == 6){
        this.gdprService.moveToImpactAssessment6(itemInfoDto).subscribe((data:any)=>{
          this.selectedItemId = 0;
          this.isLoadingRegulations = false;
          this.getAlertMessage(data);
          // if (this.checkGroupBy()) {
          //   if (this.clickedFilter != null || this.clickedFilter != "") {
          if (this.checkGroupBy()) {
            if (this.clickedFilter != null || this.clickedFilter != "") {
              this.getPannelData(this.selectedPanelData, this.clickedFilter);
            }
            else {
              this.getPannelData(this.selectedPanelData);
            }
          }
          else {
            this.getRegulation();
          }
          this.selectedPanelName = [];
          this.selectedItems = [];
          this.clickedFilter = "";
        });
      }
      else if(this.templateNo == 5){
        this.gdprService.moveToImpactAssessment5(itemInfoDto).subscribe((data: any) => {
          this.selectedItemId = 0;
          this.isLoadingRegulations = false;
          this.getAlertMessage(data);
          // if (this.checkGroupBy()) {
          //   if (this.clickedFilter != null || this.clickedFilter != "") {
          if (this.checkGroupBy()) {
            if (this.clickedFilter != null || this.clickedFilter != "") {
              this.getPannelData(this.selectedPanelData, this.clickedFilter);
            }
            else {
              this.getPannelData(this.selectedPanelData);
            }
          }
          else {
            this.getRegulation();
          }
          this.selectedPanelName = [];
          this.selectedItems = [];
          this.clickedFilter = "";
        });
      }
      else {
        this.gdprService.moveToImpactAssessment(itemInfoDto).subscribe((data: any) => {
          this.selectedItemId = 0;
          this.isLoadingRegulations = false;
          this.getAlertMessage(data);
          // if (this.checkGroupBy()) {
          //   if (this.clickedFilter != null || this.clickedFilter != "") {
          if (this.checkGroupBy()) {
            if (this.clickedFilter != null || this.clickedFilter != "") {
              this.getPannelData(this.selectedPanelData, this.clickedFilter);
            }
            else {
              this.getPannelData(this.selectedPanelData);
            }
          }
          else {
            this.getRegulation();
          }
          this.selectedPanelName = [];
          this.selectedItems = [];
          this.clickedFilter = "";
        });
      }
    });
  }

  mergeAndImpactAssessment(jurisdictions: Array<string>): void {
    const itemInfoDto = new ItemInfoDto();
    itemInfoDto.idList = this.selectedItems;
    itemInfoDto.screenUrl = this.router.url;
    itemInfoDto.jurisdictions = jurisdictions;
    this.isLoadingRegulations = true;
    this.gdprService.mergeAndImpactAssessment(itemInfoDto).subscribe((data: any) => {
      this.selectedItems = [];
      this.selectedPanelName = [];
      this.isLoadingRegulations = false;
      this.getAlertMessage(data);
    });
  }

  getAlertMessage(data: any): void {
    if (data.result?.resultId > 0 && data.result.status) {
      this.toastModel.Title = 'Success';
      this.toastModel.Type = 'success';
      this.toastModel.Message = 'Regulation Moved to Impact Assessment';
    } else if (!data.result?.status && data.result?.message) {
      this.toastModel.Title = 'Warning';
      this.toastModel.Type = 'warning';
      this.toastModel.Message = data.result?.message
    } else {
      this.toastModel.Title = 'Warning';
      this.toastModel.Type = 'warning';
      this.toastModel.Message =
        'Impact Assessment on this Change Id already exists';
    }
    this.isToastShow = true;
    setTimeout(() => {
      this.isToastShow = false;
      if (data.result?.resultId > 0) {
        this.openAssessmentPopup(data.result.resultId, this.templateNo);
      }
    }, 5000);
  }

  downloadReport(): void {
    let datediff = this.monthDiff(new Date(this.regulationFilter.FromDate ? this.regulationFilter.FromDate : new Date()), new Date(this.regulationFilter.ToDate ? this.regulationFilter.ToDate : new Date()));
    if (datediff > 90) {
      this.toastModel.Title = 'Warning';
      this.toastModel.Type = 'warning';
      this.toastModel.Message =
        'You cant export more than 3 months of data at time';
      this.isToastShow = true;
      setTimeout(() => {
        this.isToastShow = false;
      }, 5000);
    }
    else {
      this.isLoadingRegulations = true;
      if (this.regulations.totalCount > 10000) {
        this.toastModel.Title = 'Warning';
        this.toastModel.Type = 'warning';
        this.toastModel.Message =
          'Maximum 10000 data will be exported';
        this.isToastShow = true;
        setTimeout(() => {
          this.isToastShow = false;
        }, 5000);
      }
      this.regulationService.downloadIAReport(this.regulationFilter).subscribe(
        (data: any) => {
          this.isLoadingRegulations = false;
          // tslint:disable-next-line:one-variable-per-declaration
          const a = document.createElement('a'),
            fileURL = URL.createObjectURL(data);
          a.href = fileURL;
          a.download = `ChangeViewerReport.xlsx`;
          window.document.body.appendChild(a);
          a.click();
          window.document.body.removeChild(a);
        },
        (err: HttpErrorResponse) => {
          this.isLoadingRegulations = false;
          console.error(JSON.stringify(err.message));
        }
      );
    }

  }
  monthDiff(dateFrom: Date, dateTo: Date): number {
    return Math.floor((Date.UTC(dateTo.getFullYear(), dateTo.getMonth(), dateTo.getDate()) - Date.UTC(dateFrom.getFullYear(), dateFrom.getMonth(), dateFrom.getDate())) / (1000 * 60 * 60 * 24));
  }
  // Chnage Viewer Report changes due to modal view screen breaking issue
  // Soutsav Nandy - Amit Madahar 05-Jun-2023
  // openDetailDialog(id: number, filter: string, similarIndex: string): void {
  openDetailDialog(id: number, filter: string, similarIndex: string, pannelData: any[]) {
    const regulationData = new RegulationDataModel();
    regulationData.id = id;
    regulationData.libraryId = this.regulationFilter.regulationLibraryId;
    //regulationData.regulations = this.regulations.data;
    if (pannelData != null && pannelData.length > 0) {
      regulationData.regulations = pannelData
    }
    else {
      regulationData.regulations = this.regulations.data;
    }
    regulationData.filterType = filter;
    regulationData.similarIndex = similarIndex;
    const dialogRef = this.dialog.open(ChangeViewerAnalyticDialogComponent, {
      width: '92vw',
      height: '85vh',
      data: regulationData,
    });
    dialogRef.afterClosed().subscribe((result) => { });
  }

  showHideData(id: number, filter: string): void {
    if (filter === 'Show') {
      this.collapsedIds.push(id);
    } else {
      const index = (this.collapsedIds as number[]).indexOf(id);
      if (index >= 0) {
        (this.collapsedIds as number[]).splice(index, 1);
      }
    }
  }

  checkCollapsed(id: number): boolean {
    const index = (this.collapsedIds as number[]).indexOf(id);
    return index >= 0 ? true : false;
  }

  sortArray(itemArray: string[]): string[] {
    return MasterHelper.sortArray(itemArray, 'asc');
  }

  openStaticLibrary(): void {
    if (this.selectedItems.length > 0) {
      const item = new AlertDialogModel();
      item.HeadingText = 'Static Library';
      item.BodyText = 'Library Name';
      item.ActionButtonText = 'Save';
      item.IsAction = false;
      const dialogRef = this.dialog.open(RegulationLibraryDialogComponent, {
        width: '1000px',
        data: item,
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.addToLibrary(result);
        }
        else {
          this.RedirectionAfterLibraryDelete("cancel");
        }
      });
    } else {
      this.warningAlert('Please select at least one publication to create Static Library');
    }
  }

  openDynamicLibrary(): void {
    this.selectedPanelName = [];
    this.selectedItems = [];
    const item = new AlertDialogModel();
    item.HeadingText = 'Dynamic Library';
    item.BodyText = 'Library Name';
    item.ActionButtonText = 'Save';
    item.IsAction = true;
    const dialogRef = this.dialog.open(RegulationLibraryDialogComponent, {
      width: '1000px',
      data: item,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.addToLibrary(result);
      }
      else {
        this.RedirectionAfterLibraryDelete("cancel");
      }
    });
  }

  addToLibrary(libraryData: LibraryDataModel): void {
    this.isLoadingRegulations = true;
    libraryData.regulationIds =
      libraryData.libraryType === LibraryType.Static ? this.selectedItems : [];
    libraryData.fromDate = this.regulationFilter.FromDate;
    libraryData.toDate = this.regulationFilter.ToDate;
    this.regulationService.saveToMyLibrary(libraryData).subscribe((data: any) => {
      this.selectedItems = [];
      this.selectedPanelName = [];
      this.successAlert(data.message);
      this.fetchRegulationLibrary();
    });
  }

  fetchRegulationLibrary(): void {
    this.regulationService.getRegulationLibrary('OrderNo', false).subscribe((data: Array<ChangeViewerLibrary>) => {
      this.isLoadingRegulations = false;
      if (data) {
        this.regulationService.regulationLibrary = data.filter((a) => a.isActive);
        this._userService.userLibrary = this.regulationService.regulationLibrary;
        if (this.regulationLibraryType !== LibraryType.Unknown) {
          this.RedirectionAfterLibraryDelete("save");

        }
      }
    });
  }

  openSharePopup(): void {
    const dialogRef = this.dialog.open(ShareLibraryDialogComponent, {
      width: '700px',
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.shareRegulationLibrary(result);
      }
    });
  }

  shareRegulationLibrary(dataItems: FilterItemListModel): void {
    const userCurrentDivision = localStorage.getItem("selectedDivisionName");
    this.isLoadingRegulations = true;
    this.regulationService.shareRegulationLibrary(dataItems, userCurrentDivision).subscribe((data: any) => {
      this.isLoadingRegulations = false;
      this.successAlert('Regulation library share successfully');
    });
  }

  // Edit or Update Static Library Comment
  editComment(staticLibraryComment: string, id: number): void {
    const obj = new StaticLibraryEditView();
    obj.updatesDbId = id;
    obj.libraryId = this.regulationFilter.regulationLibraryId;

    // if (this.selectedItems.length > 1) {
    //   obj.comment = this.getBulkComment();
    // } else {
    //   obj.comment = this.getCommentArray(staticLibraryComment);
    // }
    const dialogRef = this.dialog.open(StaticLibraryDialogComponent, {
      width: '750px',
      data: obj,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.updateStaticLibraryTopic(result);
      }
    });
  }

  getCommentArray(staticLibraryComment: string): string[] {
    let resultComment: string[] = [];
    if (staticLibraryComment) {
      resultComment = staticLibraryComment.split(',');
    }
    resultComment = MasterHelper.removeNullFromArray(resultComment);
    return this.sortArray(resultComment);
  }

  getBulkComment(): string[] {
    let bulkComment = '';
    this.selectedItems.forEach((itemId) => {
      const regData = this.regulations.data.find((a) => a.id === itemId);
      if (regData?.staticLibraryComment) {
        bulkComment = bulkComment + ',' + regData.staticLibraryComment;
      }
    });
    let resultComment = bulkComment ? bulkComment.split(',') : [];
    resultComment = MasterHelper.removeNullFromArray(resultComment);
    return this.sortArray(resultComment);
  }

  updateStaticLibraryTopic(obj: StaticLibraryViewModel): void {
    obj.updatesDbIdList = this.selectedItems.length > 1 ? this.selectedItems : [];
    this.regulationService.updateStaticLibraryInfo(obj).subscribe((data: StaticRegulationLibrary) => {
      this.successAlert('Update Successfully');
      if (this.selectedItems.length > 1) {
        this.selectedItems.forEach((item) => {
          let regulationData = this.regulations.data.find(
            (a) => a.id === item
          )
          if (regulationData) {
            regulationData.staticLibraryComment = data.comment;
          }
        });
      } else {
        let regulationData = this.regulations.data.find(
          (a) => a.id === obj.updatesDbId
        );
        if (regulationData) {
          regulationData.staticLibraryComment = data.comment;
        }
      }
      this.selectedItems = [];
      this.selectedPanelName = [];
    });
  }

  deleteStaticLibraryItem(): void {
    if (this.selectedItems.length > 0) {
      this.isLoadingRegulations = true;
      const deleteItems = new ItemArraryModel();
      deleteItems.itemIds = this.selectedItems;
      deleteItems.id = this.regulationLibraryId;
      this.regulationService.removeStaticLibraryitem(deleteItems).subscribe((data: any) => {
        this.selectedItems = [];
        this.selectedPanelName = [];
        this.getRegulation();
      });
    } else {
      this.warningAlert('Please select at least one');
    }
  }

  getElementsByFilter(itemArray: string[], filter: string): string[] {
    if (filter === 'All') {
      return itemArray && itemArray.length > 5 ? itemArray.slice(5, itemArray.length - 1) : itemArray;
    } else {
      return itemArray && itemArray.length > 5 ? itemArray.slice(0, 5) : itemArray;
    }
  }

  showHideSimilarity(id: number): void {
    const index = this.showMoreSimilarity.indexOf(id);
    if (index >= 0) {
      this.showMoreSimilarity.splice(index, 1);
    } else {
      this.showMoreSimilarity.push(id);
    }
  }

  showMoreLessResult(id: number): boolean {
    const index = this.showMoreSimilarity.indexOf(id);
    return index >= 0 ? true : false;
  }

  openAssessmentPopup(id: number, templateNo: number): void {
    const dialogRef = this.dialog.open(AssessmentDialogComponent, {
      width: '1800px',
      height: '870px',
      data: [id, templateNo]
    });
    dialogRef.afterClosed().subscribe(() => {
      //this.getRegulation();
    });
  }

  searchRuleTopic(topic: string): void {
    this.regulationFilter.Filters.RuleTopic = [];
    const index = topic.indexOf('[');
    const topicStr = index >= 0 ? topic.substring(0, index - 1) : topic;
    this.regulationFilter.Filters.RuleTopic.push(topicStr.trim());
    this.saveOnBrowser(this.filterPersistenceKey, JSON.stringify(this.regulationFilter));
    this.getRegulation();
  }

  showHideColumn(item: string, itemWidth: number, isHide: boolean, filter: string): void {
    switch (item) {
      case 'Id':
        this.regColumn.id = isHide;
        break;
      case 'Geography':
        this.regColumn.geography = isHide;
        break;
      case 'Country':
        this.regColumn.country = isHide;
        break;
      case 'Regulator':
        this.regColumn.regulator = isHide;
        break;
      case 'Pub Type':
        this.regColumn.pubType = isHide;
        break;
      case 'Title':
        this.regColumn.title = isHide;
        break;
      case 'Publish Date':
        this.regColumn.publishDate = isHide;
        break;
      case 'Division':
        this.regColumn.division = isHide;
        break;
      case 'UpdatedBy':
        this.regColumn.updatedBy = isHide;
        break;
      case 'Is Manual':
        this.regColumn.isManual = isHide;
        break;
      case 'FinregE Topics':
        this.regColumn.finregeTopics = isHide;
        break;
      case 'Org Topics':
        this.regColumn.orgTopics = isHide;
        break;
      case 'Group By':
        if (isHide == false) {
          this.regulationFilter.PageSize = 0;
        }
        this.selectedPanelName = [];
        this.selectedItems = [];
        this.store.select(getGroupByEnabled).pipe(first()).subscribe(res => {
          filter === 'OnLoad' ? '' : this.checkGroupBy() ? (res ? "" : this.getGroupData()) : this.getRegulation();
          this.store.dispatch(updateGroupByEnabled({ data: this.checkGroupBy() ? true : false }))
        })
        break;
    }

    if (filter === 'Change') {
      this.tableWidth = isHide ? this.tableWidth + itemWidth : this.tableWidth - itemWidth;
    } else if (!isHide) {
      this.tableWidth = isHide ? this.tableWidth + itemWidth : this.tableWidth - itemWidth;
    }
    this.eleRef.nativeElement.style.setProperty('--table-min-width', this.tableWidth + 'px');
    MasterHelper.saveOnBrowser(this.regType, JSON.stringify(this.itemActiveModel));
  }

  removeItemFromArray(title: string): void {
    this.itemActiveModel.forEach((item, index) => {
      if (item.itemTitle === title) {
        this.itemActiveModel.splice(index, 1);
      }
    });
  }

  isCurrentAction(event: any): void {
    if (event) {
      this.eleRef.nativeElement.style.setProperty('--side-border', '1px solid rgba(0, 0, 0, 0.16)');
    }
  }

  openPublishReport(): void {
    const dialogRef = this.dialog.open(PublishReportDialogComponent, {
      width: '750px',
      data: this.selectedItems
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.fetchPublishReport(result);
      }
    });
  }

  fetchPublishReport(filter: PublishRegulationFilter): void {
    this.isLoadingRegulations = true;
    this.regulationService.getPublishReport(filter).subscribe((result: PublishReportResponse) => {
      this.isLoadingRegulations = false;
      this.saveOnBrowser('_prod', JSON.stringify(result));
      window.open('/publish-report', '_blank');
    });
  }

  onDatePicker(event: any): void {
    if (event.startDate && event.endDate) {
      this.regulations.data = this.allRegulations.filter(a => MasterHelper.parseDateStr(a.date) >= event.startDate
        && MasterHelper.parseDateStr(a.date) <= event.endDate);
    } else {
      this.regulations.data = this.allRegulations;
    }
    this.resultRegulations.data.next(this.regulations.data);
  }

  openEditDialog(): void {
    this.fetchAllLibrary();
    if (this.regulationService.regulationLibrary && this.regulationService.regulationLibrary.length > 0) {
      const itemInfo = new AlertDialogModel();
      itemInfo.HeadingText = 'Edit Library';
      itemInfo.BodyText = 'Library Name';
      itemInfo.ActionButtonText = 'Update';
      itemInfo.AlertMsg = 'Please enter library name.';
      const dialogRef = this.dialog.open(EditInfoDialogComponent, {
        width: '750px',
        data: itemInfo,
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.updateLibraryInfo(result);
        }
      });
    } else {
      this.warningAlert('No Library Exist');
    }
  }

  updateLibraryInfo(editInfo: AlertDialogModel): void {
    this.regulationService.updateLibraryInfo(editInfo).subscribe((result: ChangeViewerLibrary) => {
      this.fetchRegulationLibrary();
    });
  }

  fetchAllLibrary(): void {
    this.regulationService.getRegulationLibrary('LibraryName', false).subscribe((data: Array<ChangeViewerLibrary>) => {
      this.isLoadingRegulations = false;
      if (data) {
        if (this.regulationLibraryType !== LibraryType.Unknown) {
          this.getRegulation();
        }
      }
    });
  }
  IsRowEdited(): void {
    //For Work Item 273 bold unbold issue -- Soustav
    this.processAssessData();
    this.resultRegulations.data.forEach(element => {
      element.forEach(item => {
        if (this.regulationFilter.FilterType !== 'Actioned'
          && this.regulationFilter.FilterType !== 'Other'
          && this.commonService.checkPlanTypeAction(this.cCode)) {
          item.isRowBold = true;
        }

        else if (this.regulationFilter.FilterType === 'Other' || this.regulationLibraryType > 0 && this.commonService.checkPlanTypeAction(this.cCode)) {
          if (item.isAssessed || item.isClosed) {
            item.isRowBold = false;
          }
          else {
            item.isRowBold = true;
          }
        }

        else if ((this.regulationFilter.FilterType === 'Other') && !this.checkPermission(item.jurisdiction)
          && this.commonService.checkPlanTypeAction(this.eCode)) {
          item.isRowBold = false;
        }

      });

    });
  }
  sortArrayByDate(itemArray: string[]): string[] {
    return MasterHelper.sortArrayByDate(itemArray, 'asc');
  }
  openAddUpdateDialog() {
    const dialogRef = this.dialog.open(AddManualUpdateComponent, {
      height: '81%',
      width: '94%',

      panelClass: 'externel-update-dialogue'
    });
    dialogRef.afterClosed().subscribe((data) => {
      if (data) {
        this.successAlert('Regulation added successfully');
        this.getRegulation();
      }
    });
  }
  EditManualUpdate(id: { toString: () => any; }) {
    const dialogRef = this.dialog.open(AddManualUpdateComponent, {
      height: '81%',
      width: '94%',
      panelClass: 'externel-update-dialogue',
      data: id.toString()
    });
    dialogRef.afterClosed().subscribe((data) => {
      if (data) {
        this.successAlert('Regulation updated successfully');
        this.getRegulation();
      }
    });
  }
  DeleteManualUpdate(id: any) {
    const dialogRef = this.dialog.open(ModalDialogComponent, {
      data: {
        message: 'Are you sure want to delete?',
        title: 'warningAlert Document',
        btnText: 'Delete',
      }
    });
    dialogRef.afterClosed().subscribe((data: any) => {
      if (data) {
        this.RemoveManualUpdate(id);
      }
    });
  }
  RemoveManualUpdate(id: number) {
    this.regulationService.removeRegulationSingleDetail(id).subscribe((result: any) => {
      this.successAlert('Regulation deleted successfully');
      this.getRegulation();
    })
  }
  countFiltersItem() {
    this.totalFilter = 0;
    if (this.regulationFilter.Country.length > 0) {
      this.totalFilter = this.totalFilter + 1;
    }
    if (this.regulationFilter.Geography.length > 0) {
      this.totalFilter = this.totalFilter + 1;
    }
    if (this.regulationFilter.MappingID && this.regulationFilter.MappingID.length > 0) {
      this.totalFilter = this.totalFilter + 1;
    }
    if (this.regulationFilter.Filters.RuleTopic.length > 0) {
      this.totalFilter = this.totalFilter + 1;
    }
    if (this.regulationFilter.RegulationId.length > 0) {
      this.totalFilter = this.totalFilter + 1;
    }
    if (this.regulationFilter.SearchQuery.length > 0) {
      this.totalFilter = this.totalFilter + 1;
    }
    if (this.regulationFilter.Filters.PubType.length > 0) {
      this.totalFilter = this.totalFilter + 1;
    }
    if (this.regulationFilter.Filters.Title.length > 0) {
      this.totalFilter = this.totalFilter + 1;
    }
    if (this.regulationFilter.Filters.LinkedRules.length > 0) {
      this.totalFilter = this.totalFilter + 1;
    }
    let date = new Date();
    let toDate = formatDate(date, 'yyyy-MM-dd', 'en-US');

    date.setDate(date.getDate() - 7);
    let fromDate = formatDate(date, 'yyyy-MM-dd', 'en-US');
    if (this.regulationFilter.FilterType !== 'Future Updates') {
      if ((formatDate(this.regulationFilter.ToDate, 'yyyy-MM-dd', 'en-US') != toDate || formatDate(this.regulationFilter.FromDate, 'yyyy-MM-dd', 'en-US') != fromDate)) {
        this.totalFilter = this.totalFilter + 1;
      }
    }

  }
  resetFilterItem() {
    const persistFilter = JSON.parse(this.fetchFromBrowser(this.filterPersistenceKey) as string) as RegulationFilterModel;
    if (persistFilter) {
      persistFilter.Page = 1;
      this.regulationFilter = persistFilter;
    }
    this.countFiltersItem();
  }
  RedirectionAfterLibraryDelete(closeType: string) {
    if (this.regulationFilter.regulationLibraryId && this.regulationFilter.regulationLibraryId > 0
      && this.regulationFilter.regulationLibraryType && this.regulationFilter.regulationLibraryType > 0) {
      let filterLibrary = this.regulationService.regulationLibrary.filter((ob) => ob.id == this.regulationFilter.regulationLibraryId && ob.libraryType == this.regulationFilter.regulationLibraryType)
      if (filterLibrary.length == 0) {
        this.regulationFilter.regulationLibraryId = 0;
        this.regulationFilter.regulationLibraryType = LibraryType.Unknown;
        this.saveOnBrowser(this.filterPersistenceKey, JSON.stringify(this.regulationFilter));
        this.router.navigate([
          "/change-viewer/open"
        ]);
      }
      else if (closeType == "save") {
        if (this.checkGroupBy())
          this.getGroupData(true);
        else
          this.getRegulation();
      }
    }
  }
  @HostListener('window:keyup', ['$event'])
  keyEventUp(event: KeyboardEvent) {
    if (event.key == 'Shift') {
      this.isShiftSelect = false;
    }
  }

  @HostListener('window:keydown', ['$event'])
  keyEventDown(event: KeyboardEvent) {
    if (event.key == 'Shift') {
      this.isShiftSelect = true;
    }
  }
  tooltipValue(event: string | any[]) {
    let arr = [];
    for (let i = 0; i < event.length; i++) {
      arr.push(event[i].jurisdiction + '|' + event[i].regulationStatus + '|' + event[i].userName);
    }
    return arr.join("\r\n");
  }
  getContrastYIQ(hex: string) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    if (!result) return 'black';
    var r = parseInt(result[1], 16);
    var g = parseInt(result[2], 16);
    var b = parseInt(result[3], 16);
    var yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
    return (yiq >= 150) ? 'black' : 'white';
  }
  FilterDropdown() {
    this.isBackdropVisible = !this.isBackdropVisible;
  }
  mergeAssess(): void {
    if (this.selectedItems.length > 1) {
      this.addMergeAssessment();
    } else {
      this.warningAlert('Select more than one update publication to start "Merge Assess" workflow. For single update publication use "Assess" workfow');
    }
  }
  addMergeAssessment() {
    let division = localStorage.getItem('selectedDivision');
    var filterDivision = this.userJurisdiction.filter(s => s.id.toString() == division);
    const bulkInsertModel = new BulkInsertModel();
    bulkInsertModel.itemIds = this.selectedItems;
    bulkInsertModel.screenUrl = this.router.url;
    this.isLoadingRegulations = true;
    if (filterDivision && filterDivision.length > 0) {
      bulkInsertModel.jurisdictions.push(filterDivision[0].name);
    }
    if (bulkInsertModel.itemIds.length > 0) {
      bulkInsertModel.parentId = bulkInsertModel.itemIds[0];
    }
    this.gdprService.getTemplateNo().subscribe((data: any) => {
      this.templateNo = data.result;
      bulkInsertModel.templateNo = this.templateNo;
      if (this.templateNo == 4) {
        this.gdprService.moveToBulkImpactAssessmentT4(bulkInsertModel).subscribe((data: any) => {
          this.isLoadingRegulations = false;
          if (data.message === 'Saved Successfully') {
            this.successAlert("Updates moved to Impact Assessment Workflow");
            if (this.checkGroupBy()) {
              this.isLoadingRegulations = false;
              this.selectedPanelName.forEach(item => {
                let panel = this.filteredGroupData.find((x: { groupByColumnData: string; }) => x.groupByColumnData == item);
                if (panel != null) {
                  panel.isActionDone = true;
                  this.selectedSubPanelName.forEach(items => {
                    let isSubPanel = panel.otherDataSummary.find((x: { mappingIdOrPubType: string; }) => x.mappingIdOrPubType == items);
                    if (isSubPanel != null) {
                      panel.otherDataSummary.find((x: { mappingIdOrPubType: string; }) => x.mappingIdOrPubType == items).isActioned = true;
                    }
                  });
                }
              });
              if (this.selectedPanelName.length > 1) {
                this.getGroupData(true);
              }
              else {
                this.getPannelData(this.selectedPanelName.length > 0 ? this.selectedPanelName[0] : '');
              }
            }
            else
              this.getRegulation();
            this.openAssessmentPopup(data.result.resultId, this.templateNo);
          } else {
            this.warningAlert(data.message);
          }

          this.selectedPanelName = [];
          this.selectedItems = [];
          this.actionedIds = [];
        });
      }
      else if(this.templateNo == 5){
        this.gdprService.moveToBulkImpactAssessment5(bulkInsertModel).subscribe((data: any) => {
          this.isLoadingRegulations = false;
          if (data.message === 'Saved Successfully') {
            this.successAlert("Updates moved to Impact Assessment Workflow");
            if (this.checkGroupBy()) {
              this.isLoadingRegulations = false;
              this.selectedPanelName.forEach(item => {
                let panel = this.filteredGroupData.find((x: { groupByColumnData: string; }) => x.groupByColumnData == item);
                if (panel != null) {
                  panel.isActionDone = true;
                  this.selectedSubPanelName.forEach(items => {
                    let isSubPanel = panel.otherDataSummary.find((x: { mappingIdOrPubType: string; }) => x.mappingIdOrPubType == items);
                    if (isSubPanel != null) {
                      panel.otherDataSummary.find((x: { mappingIdOrPubType: string; }) => x.mappingIdOrPubType == items).isActioned = true;
                    }
                  });
                }
              });
              if (this.selectedPanelName.length > 1) {
                this.getGroupData(true);
              }
              else {
                this.getPannelData(this.selectedPanelName.length > 0 ? this.selectedPanelName[0] : '');
              }
            }
            else
              this.getRegulation();
            this.openAssessmentPopup(data.result.resultId, this.templateNo);
          } else {
            this.warningAlert(data.message);
          }

          this.selectedPanelName = [];
          this.selectedItems = [];
          this.actionedIds = [];
        });
      }
      else if(this.templateNo == 6){
        this.gdprService.moveToBulkImpactAssessmentT6(bulkInsertModel).subscribe((data: any) => {
          this.isLoadingRegulations = false;
          if (data.message === 'Saved Successfully') {
            this.successAlert("Updates moved to Impact Assessment Workflow");
            if (this.checkGroupBy()) {
              this.isLoadingRegulations = false;
              this.selectedPanelName.forEach(item => {
                let panel = this.filteredGroupData.find((x: { groupByColumnData: string; }) => x.groupByColumnData == item);
                if (panel != null) {
                  panel.isActionDone = true;
                  this.selectedSubPanelName.forEach(items => {
                    let isSubPanel = panel.otherDataSummary.find((x: { mappingIdOrPubType: string; }) => x.mappingIdOrPubType == items);
                    if (isSubPanel != null) {
                      panel.otherDataSummary.find((x: { mappingIdOrPubType: string; }) => x.mappingIdOrPubType == items).isActioned = true;
                    }
                  });
                }
              });
              if (this.selectedPanelName.length > 1) {
                this.getGroupData(true);
              }
              else {
                this.getPannelData(this.selectedPanelName.length > 0 ? this.selectedPanelName[0] : '');
              }
            }
            else
              this.getRegulation();
              this.openAssessmentPopup(data.result.resultId, this.templateNo);
          } else {
            this.warningAlert(data.message);
          }

          this.selectedPanelName = [];
          this.selectedItems = [];
          this.actionedIds = [];
        });
      }
      else {
        this.gdprService.moveToBulkImpactAssessment(bulkInsertModel).subscribe((data: any) => {
          this.isLoadingRegulations = false;
          if (data.message === 'Saved Successfully') {
            this.successAlert("Updates moved to Impact Assessment Workflow");
            if (this.checkGroupBy()) {
              this.isLoadingRegulations = false;
              this.selectedPanelName.forEach(item => {
                let panel = this.filteredGroupData.find((x: { groupByColumnData: string; }) => x.groupByColumnData == item);
                if (panel != null) {
                  panel.isActionDone = true;
                  this.selectedSubPanelName.forEach(items => {
                    let isSubPanel = panel.otherDataSummary.find((x: { mappingIdOrPubType: string; }) => x.mappingIdOrPubType == items);
                    if (isSubPanel != null) {
                      panel.otherDataSummary.find((x: { mappingIdOrPubType: string; }) => x.mappingIdOrPubType == items).isActioned = true;
                    }
                  });
                }
              });
              if (this.selectedPanelName.length > 1) {
                this.getGroupData(true);
              }
              else {
                this.getPannelData(this.selectedPanelName.length > 0 ? this.selectedPanelName[0] : '');
              }
            }
            else
              this.getRegulation();
            this.openAssessmentPopup(data.result.resultId, this.templateNo);
          } else {
            this.warningAlert(data.message);
          }

          this.selectedPanelName = [];
          this.selectedItems = [];
          this.actionedIds = [];
        });
      }
    });

  }
  filterSimilarity(ids: any, id: number) {
    const array: string[] = ids.split('||');
    const result = array.map(s => parseInt(s.split('|')[0].trim()));
    this.regulationFilter.RegulationId = [];
    this.regulationFilter.RegulationId = result;
    this.regulationFilter.RegulationId.push(id);
    this.regulationFilter.IsSimilarId = true;
    this.regulationFilter.SimilarIdFor = id;
    this.saveOnBrowser(this.filterPersistenceKey, JSON.stringify(this.regulationFilter));
    this.getRegulation();
  }
  filterSimilarityByGrouped(ids: any, id: number) {
    const array: string[] = ids.split('||');
    const result = array.map(s => parseInt(s.split('|')[0].trim()));
    this.regulationFilter.RegulationId = [];
    this.regulationFilter.RegulationId = result;
    this.regulationFilter.RegulationId.push(id);
    this.regulationFilter.IsSimilarId = true;
    this.regulationFilter.SimilarIdFor = id;
    this.saveOnBrowser(this.filterPersistenceKey, JSON.stringify(this.regulationFilter));
    this.getGroupData(true);
  }
  resetFilters(event: any) {
    this.IsOpenFilter = this.dropdownfilters.isOpen;
    if (this.IsOpenFilter == true) {
      this.regulatoryFiltersComponent?.ngOnInit();
    }
  }

  //Checking CLose and Impact Status
  processAssessData() {
    this.resultRegulations.data.subscribe((myAssess) => {
      if (myAssess.length > 0) {
        let selectedDivision = localStorage.getItem("selectedDivisionName");
        for (let i = 0; i < myAssess.length; i++) {
          if (myAssess[i].currentActions != null) {
            let assessedData = myAssess[i].currentActions.filter(element => {
              return element.closedType === 'Assess' && element.jurisdiction === selectedDivision;
            });
            let closedData = myAssess[i].currentActions.filter(element => {
              return element.closedType === 'Closed' && element.jurisdiction === selectedDivision;
            });
            if (assessedData.length > 0) {
              myAssess[i].isAssessed = true;
            } else {
              myAssess[i].isAssessed = false;
            }
            if (closedData.length > 0) {
              myAssess[i].isClosed = true;
            } else {
              myAssess[i].isClosed = false;
            }
          }
        }
      }
    });
  }
  //tooltip code
  private findTooltipById(searchId: string): Tooltip | undefined {
    return this.tooltips.find(tooltip => tooltip.el.nativeElement.id === searchId);

  }

  onClick(id: number, regulator: string) {
    const foundTooltip = this.findTooltipById(id.toString());
    if (foundTooltip) {
      if (foundTooltip.active) {
        foundTooltip.deactivate();
        this.isShowingTooltip = false;
      }
      else {
        if (this.isShowingTooltip) {
          const lastfoundTooltip = this.findTooltipById(this.lastTooltipId.toString());
          if (lastfoundTooltip) {
            lastfoundTooltip.deactivate();
          }
        }
        foundTooltip.activate();
        this.isShowingTooltip = true;
        this.lastTooltipId = id;
        this.getDescription(regulator);
      }
    }
  }
  getDescription(regulator: string) {
    this.regulationService.getDescription(regulator).subscribe((data: RegulationDescription) => {
      if (data.description) {
        this.tooltipText = data.description;
      }
      else {
        this.tooltipText = "No Description Found";
      }
    });
  }
  //append assess start
  openAappendAssessDialog() {
    if (this.selectedItems.length > 0) {
      const dialogRef = this.dialog.open(AppendAssessListComponent, {
        height: 'auto',
        width: '70%',
      });
      dialogRef.afterClosed().subscribe((data) => {
        if (data) {
          
          const mergeAssess: MergeAssess = { impactId: data, appendIds: this.selectedItems };
          this.saveIdsInAssess(mergeAssess)
        }
      });
    }
    else{
      this.warningAlert("Please select at least one regulation");
    }

  }
  async saveIdsInAssess(data: MergeAssess) {
    this.isLoadingRegulations=true;
    this.gdprService.saveIdsInAssess(data).subscribe((data: any) => {
      this.isLoadingRegulations=false;
      if (data.data == "success") {
        this.successAlert('Regulations added to impact assessments successfully');
        if (this.checkGroupBy())
        this.getGroupData(true);
      else
        this.getRegulation();
      }
      else {
        this.warningAlert(data.data);
      }
    });
  }
  //append assess end
}

export interface ActionedPanel {
  id: number;
  name: string;
}


